const SOURCE_FILES = {
  F02: "frontend/src/layouts/GameLayout.js",
  F03: "frontend/src/pages/user/Learn.js",
  F04: "frontend/src/content/learnPages.js",
  F08: "docs/xima-knowledge/*.md",
  F10: "frontend/src/pages/user/Lobby.js",
  F11: "frontend/src/pages/user/CreateGame.js",
  F12: "frontend/src/pages/user/Index.js",
  F13: "frontend/src/pages/user/PlayBot.js",
  F14: "frontend/src/pages/user/PlaySandbox.js",
  F15: "frontend/src/pages/user/PlayLocalFriends.js",
  F16: "frontend/src/pages/user/PlayTournaments.js",
  F17: "frontend/src/pages/user/SpectateMatches.js",
  F18: "frontend/src/pages/user/History.js",
  F19: "frontend/src/pages/user/Stats.js",
  F20: "frontend/src/pages/user/Ranking.js",
  F21: "frontend/src/pages/user/Friends.js",
  F22: "frontend/src/pages/user/FriendProfile.js",
  F23: "frontend/src/pages/user/Store.js",
  F24: "frontend/src/pages/user/DesignMode.js",
  F25: "frontend/src/pages/user/Settings.js",
  F27: "frontend/src/services/voiceControl.js",
  F29: "frontend/src/constants/termsAndConditions.js",
  F30: "frontend/src/constants/skinStoreCatalog.js",
  F31: "frontend/src/components/LoginForm.js; frontend/src/components/RegisterForm.js; backend/controllers/authController.js; backend/models/User.js",
  F32: "backend/routes/tournament.js; backend/controllers/tournament.js; backend/models/Tournament.js",
  F33: "backend/routes/replay.js; backend/controllers/replayController.js; backend/models/MatchHistory.js",
  F34: "backend/routes/friends.js; backend/controllers/friendsController.js; backend/models/FriendInvite.js; backend/models/Friendship.js",
  F35: "backend/routes/orders.js; backend/controllers/orderController.js; backend/models/Order.js",
  F38: "backend/routes/scienceBot.js; Xima_Game/Assets/Scripts/Core/ScienceBot/ScienceBotMoveSelector.cs",
  F39: "Xima_Game/Assets/Scripts/UI/StartPanel.cs",
  F41: "Xima_Game/Assets/Scripts/Core/Stage.cs; Xima_Game/Assets/Scripts/Core/Cube.cs; Xima_Game/Assets/Scripts/Player.cs; Xima_Game/Assets/Scripts/Core/TurnsManager.cs",
  F42: "Xima_Game/Assets/Scripts/Dice.cs; Xima_Game/Assets/Scripts/DiceUI.cs; Xima_Game/Assets/Scripts/RandomBot.cs; Xima_Game/Assets/Scripts/CienzarBot.cs",
  F43: "Xima_Game/Assets/Scripts/UI/UIManager.cs; Xima_Game/Assets/Scripts/UI/GameUI.cs; Xima_Game/Assets/Scripts/UI/GameModeDisplay.cs",
  F44: "Xima_Game/Assets/Scripts/Core/OnlineMultiplayerBridge.cs",
  F45: "Xima_Game/Assets/Scripts/CameraOrbit.cs; Xima_Game/Assets/Scripts/Core/VoiceCameraBridge.cs",
  F46: "Xima_Game/Assets/Scripts/UI/SpecialCubeSkinSelectionUI.cs; Xima_Game/Assets/Scripts/Core/SpecialCubeSkinManager.cs; Xima_Game/Assets/Scripts/Core/SpecialCubeSkinApplier.cs",
  F47: "Xima_Game/Assets/Scripts/UI/CIMAX.cs; Xima_Game/Assets/Scripts/UI/PuntuacionCimax.cs; Xima_Game/Assets/Scripts/Core/CimaxTracker.cs; backend/utils/cimaxScoring.js",
  F49: "frontend/src/services/language.js; frontend/src/i18n.js",
};

const CATEGORY_META = {
  reglas: {
    label: "Reglas",
    path: "reglas",
    headings: ["Regla verificada", "Como se aplica", "Puntos de cuidado"],
  },
  tutorial: {
    label: "Tutoriales",
    path: "como-jugar",
    headings: ["Antes de empezar", "Pasos del flujo", "Recomendacion publica"],
  },
  modos: {
    label: "Modos",
    path: "modos-de-juego",
    headings: ["Modo verificado", "Uso en partida", "Limites de documentacion"],
  },
  partidas: {
    label: "Partidas online",
    path: "partidas-online",
    headings: ["Funcion verificada", "Como se usa", "Notas para jugadores"],
  },
  interfaz: {
    label: "Interfaz",
    path: "lobby",
    headings: ["Elemento visible", "Uso recomendado", "Relacion con Aprender"],
  },
  movil: {
    label: "Movil",
    path: "compatibilidad-movil",
    headings: ["Vista movil", "Como navegar", "Confirmaciones pendientes"],
  },
  replay: {
    label: "Historial y replay",
    path: "historial-y-replay",
    headings: ["Funcion de replay", "Como interpretarla", "Limites del registro"],
  },
  solucion: {
    label: "Solucion",
    path: "solucion-de-problemas",
    headings: ["Problema visible", "Revision segura", "Cuando contactar soporte"],
  },
  progreso: {
    label: "Estadisticas",
    path: "estadisticas",
    headings: ["Metrica visible", "Como leerla", "Precauciones"],
  },
  ranking: {
    label: "Ranking",
    path: "ranking",
    headings: ["Tabla verificada", "Lectura recomendada", "Puntos pendientes"],
  },
  perfil: {
    label: "Perfil",
    path: "perfil",
    headings: ["Dato visible", "Uso en la cuenta", "Privacidad"],
  },
  comunidad: {
    label: "Amigos",
    path: "amigos",
    headings: ["Funcion social", "Como usarla", "Privacidad y seguridad"],
  },
  torneos: {
    label: "Torneos",
    path: "torneos",
    headings: ["Sistema visible", "Como participar", "Pendientes oficiales"],
  },
  entrenamiento: {
    label: "Puzzles",
    path: "puzzles",
    headings: ["Entrenamiento verificado", "Como practicar", "Limites publicos"],
  },
  bots: {
    label: "Bots",
    path: "bots",
    headings: ["IA visible", "Como entrenar", "Limites de la guia"],
  },
  tienda: {
    label: "Tienda",
    path: "tienda",
    headings: ["Producto visible", "Uso en la plataforma", "Revision comercial"],
  },
};

const sourceRefs = (codes) => (codes || []).map((code) => SOURCE_FILES[code] || code);

const link = (label, slug) => ({ label, path: slug });

const faq = (question, answer) => ({ question, answer });

const buildLinks = (route, links) =>
  (links || []).map((item) => ({
    label: item.label,
    path: route(item.path),
  }));

const buildCta = (route, spec, category) => {
  const cta = spec.cta || { label: `Ver ${category.label.toLowerCase()}`, path: category.path };
  return {
    label: cta.label,
    path: route(cta.path),
  };
};

const buildSections = (spec, category) => {
  const headings = spec.headings || category.headings;
  const sections = [
    { heading: headings[0], body: spec.verified },
    { heading: headings[1], body: spec.usage },
    { heading: headings[2], body: spec.caution },
  ];

  return sections;
};

const buildBreadcrumbs = (route, spec, category) => [
  { label: category.label, path: route(category.path) },
  { label: spec.h1, path: route(spec.slug) },
];

const defaultScreenshots = (spec) => [
  `Referencia visual de ${spec.h1}`,
  `Estado relacionado con ${spec.h1} dentro de XIMA`,
];

const buildLearnPage = ({ page, route, canonical }, spec) => {
  const category = CATEGORY_META[spec.category] || CATEGORY_META.tutorial;
  const status = spec.status || "verified";
  const steps = spec.steps || [];

  return page({
    slug: spec.slug,
    friendlyUrl: canonical(spec.slug),
    title: spec.title,
    metaDescription: spec.metaDescription,
    h1: spec.h1,
    intro: spec.intro,
    sections: buildSections(spec, category),
    stepsTitle: spec.stepsTitle,
    stepsNote: spec.stepsNote,
    steps,
    examples: spec.examples || [],
    screenshots: spec.screenshots || defaultScreenshots(spec),
    faqs: spec.faqs || [],
    internalLinks: buildLinks(route, spec.links),
    cta: buildCta(route, spec, category),
    breadcrumbs: buildBreadcrumbs(route, spec, category),
    sources: sourceRefs(spec.sources),
    status,
    robots: spec.robots || (status === "ownerConfirmation" ? "noindex,follow" : "index,follow"),
    structuredDataType: spec.structuredDataType || (steps.length > 0 ? "HowTo" : "Article"),
  });
};

const NEXT_HUNDRED_TOPICS = [
  {
    slug: "reglas/incorporar-bloque",
    category: "reglas",
    title: "Incorporar un bloque en XIMA | Regla y uso en partida",
    metaDescription:
      "Aprende que significa incorporar un bloque en XIMA, cuando se usa y como se relaciona con turnos, tablero y movimientos validos.",
    h1: "Incorporar un bloque",
    intro:
      "Incorporar un bloque es una de las acciones base de XIMA: permite poner en juego un bloque que estaba fuera del tablero.",
    verified:
      "Las reglas publicas indican que al iniciar la partida los bloques estan fuera del tablero y que, en su turno, el jugador puede incorporar un bloque nuevo o mover uno ya colocado.",
    usage:
      "La incorporacion abre presencia en el tablero y debe respetar que el primer y ultimo paso esten sobre el tablero. Despues de entrar, el bloque ya no puede moverse fuera.",
    caution:
      "Los ejemplos exactos de casilla de entrada deben verificarse en una partida real antes de usarse como diagrama oficial.",
    steps: [
      "Espera tu turno.",
      "Elige un bloque propio que todavia este fuera del tablero.",
      "Selecciona una entrada valida segun el tablero y el modo de juego.",
      "Confirma la jugada solo si el destino queda dentro del tablero.",
      "Continua el turno segun las reglas activas de la partida.",
    ],
    examples: [
      "Si aun no tienes presencia en una zona, incorporar un bloque puede abrir una ruta nueva.",
      "Si el bloque ya entro al tablero, la guia correcta pasa a ser mover un bloque.",
    ],
    faqs: [
      faq("Incorporar y mover son lo mismo?", "No. Incorporar trae un bloque desde fuera; mover desplaza uno que ya esta en el tablero."),
      faq("Un bloque incorporado puede salir despues?", "No. La regla publica indica que los bloques no pueden moverse fuera del tablero una vez que entran."),
    ],
    links: [
      link("Mover un bloque", "reglas/mover-bloque"),
      link("Turnos en XIMA", "reglas/turnos"),
      link("Tablero y casillas", "reglas/tablero-y-casillas"),
    ],
    cta: { label: "Ver movimientos", path: "reglas/movimientos" },
    sources: ["F08", "F41", "F43", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "reglas/mover-bloque",
    category: "reglas",
    title: "Mover un bloque en XIMA | Lineas, altura y tablero",
    metaDescription:
      "Guia verificada sobre mover un bloque en XIMA: linea recta, tablero, altura, turnos y relacion con jugadas legales.",
    h1: "Mover un bloque",
    intro:
      "Mover un bloque significa desplazar una pieza propia que ya se encuentra en el tablero durante un turno valido.",
    verified:
      "Las reglas publicas establecen que los bloques se mueven en linea recta en direccion vertical, horizontal o diagonal, con la distancia permitida por el modo.",
    usage:
      "En Ciencia el jugador decide el movimiento dentro de las reglas. En modos con Azar, los dados pueden limitar la cantidad de pasos.",
    caution:
      "La guia no reemplaza la validacion del juego: si Unity no permite el destino, el movimiento debe tratarse como no permitido.",
    steps: [
      "Selecciona un bloque propio que este dentro del tablero.",
      "Busca un destino en linea recta.",
      "Comprueba que el trayecto no salga del tablero.",
      "Respeta la restriccion de altura y las reglas del modo.",
      "Ejecuta la jugada cuando el destino aparezca como valido.",
    ],
    examples: [
      "Un bloque puede desplazarse por una fila si el camino y la altura lo permiten.",
      "En Azar, el numero de pasos debe coordinarse con el resultado de los dados.",
    ],
    faqs: [
      faq("Puedo mover en curva?", "No. La regla publica habla de movimiento en linea recta."),
      faq("El modo cambia el movimiento?", "Si. La base es comun, pero los dados y opciones de practica pueden cambiar la forma de elegir el desplazamiento."),
    ],
    links: [
      link("Jugada legal", "reglas/jugada-legal"),
      link("Dados en XIMA", "reglas/dados"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Revisar jugada legal", path: "reglas/jugada-legal" },
    sources: ["F08", "F41", "F43", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "reglas/subir-bloques",
    category: "reglas",
    title: "Subir bloques en XIMA | Altura y movimiento valido",
    metaDescription:
      "Conoce como funciona subir bloques en XIMA segun las reglas publicas de altura, tablero y movimiento entre casillas.",
    h1: "Subir en el tablero",
    intro:
      "Subir en XIMA depende de las reglas de altura del tablero y de que el bloque pueda alcanzar una casilla valida.",
    verified:
      "La documentacion publica indica que los bloques pueden subir o bajar en su proximo paso a lugares que tengan como maximo su misma altura.",
    usage:
      "Esta regla ayuda a leer rutas hacia niveles superiores y a entender por que algunos destinos visualmente cercanos no siempre son legales.",
    caution:
      "Los ejemplos visuales de subida necesitan confirmacion con tablero real antes de publicarse como casos oficiales.",
    confirmation:
      "La regla general esta verificada, pero faltan capturas oficiales de ejemplos de subida, bajada y bloqueo por altura.",
    examples: [
      "Una subida puede ser valida si el siguiente punto cumple la restriccion de altura.",
      "Una ruta puede fallar aunque este cerca si el cambio de altura no respeta la regla.",
    ],
    faqs: [
      faq("Subir siempre acerca a la cima?", "No necesariamente. Subir cambia la posicion vertical, pero la jugada debe seguir siendo legal."),
      faq("Esta pagina tiene ejemplos definitivos?", "Aun no. Los ejemplos quedan pendientes de confirmacion visual."),
    ],
    links: [
      link("Tablero y casillas", "reglas/tablero-y-casillas"),
      link("Mover un bloque", "reglas/mover-bloque"),
      link("Cima", "reglas/cima"),
    ],
    cta: { label: "Ver tablero", path: "reglas/tablero-y-casillas" },
    sources: ["F08", "F41", "frontend/public/rules/es/xima-rules.json"],
    status: "partial",
  },
  {
    slug: "reglas/rescate",
    category: "reglas",
    title: "Rescate de bloques en XIMA | Cuando el especial fue capturado",
    metaDescription:
      "Explicacion prudente del rescate en XIMA: que ocurre cuando el bloque especial fue capturado y que falta confirmar.",
    h1: "Rescate de bloques",
    intro:
      "El rescate aparece cuando un jugador necesita recuperar su bloque especial despues de una captura.",
    verified:
      "La regla publica indica que, si el bloque especial fue capturado, el jugador afectado puede llevar un bloque comun a la cima para rescatarlo.",
    usage:
      "El rescate conecta captura, cima y reincorporacion del bloque especial. Por eso debe explicarse con cuidado y con ejemplos revisados.",
    caution:
      "No se publican aqui variaciones finas, prioridades ni casos de borde que no esten confirmados por el propietario.",
    confirmation:
      "Falta confirmar la redaccion oficial de ejemplos y casos limite del rescate antes de tratar esta pagina como regla definitiva.",
    examples: [
      "Si tu especial fue capturado, la cima puede funcionar como objetivo de rescate para un comun.",
      "Si tu especial no fue capturado, un comun no debe presentarse como ganador por llegar a la cima.",
    ],
    faqs: [
      faq("El rescate gana la partida?", "La regla publica lo describe como recuperacion del bloque especial, no como victoria normal."),
      faq("Por que esta guia esta marcada como pendiente?", "Porque los casos visuales de rescate necesitan redaccion oficial antes de indexarse como referencia final."),
    ],
    links: [
      link("Bloque especial", "reglas/bloque-especial"),
      link("Cima", "reglas/cima"),
      link("Bloques comunes y especiales", "reglas/bloques"),
    ],
    cta: { label: "Ver bloque especial", path: "reglas/bloque-especial" },
    sources: ["F08", "F41", "frontend/public/rules/es/xima-rules.json"],
    status: "partial",
  },
  {
    slug: "reglas/jugada-legal",
    category: "reglas",
    title: "Jugada legal en XIMA | Como saber si un movimiento es valido",
    metaDescription:
      "Aprende que hace que una jugada sea legal en XIMA segun turno, tablero, linea recta, altura, modo y validacion del juego.",
    h1: "Jugada legal",
    intro:
      "Una jugada legal es una accion que el juego puede aceptar porque respeta las reglas activas del tablero y del modo.",
    verified:
      "La implementacion valida movimientos con reglas de tablero, altura, destino, bloque seleccionado, modo de juego y estado de la partida.",
    usage:
      "Para aprender, conviene revisar la jugada en capas: turno correcto, bloque propio, destino dentro del tablero, linea recta y restricciones especiales.",
    caution:
      "Esta guia evita exponer codigos internos de rechazo; se concentra en explicaciones publicas para jugadores.",
    examples: [
      "Mover fuera del tablero despues de incorporar no es una jugada legal.",
      "Intentar una distancia de dados incorrecta en Azar puede generar rechazo de movimiento.",
    ],
    faqs: [
      faq("Quien decide si una jugada es legal?", "La regla visible y la validacion del juego deben coincidir; si el juego rechaza la jugada, revisa la causa publica."),
      faq("Una jugada legal cambia por modo?", "Si. Ciencia, Azar, Cienzar, Ciencia V/S Azar y FreeBox pueden activar condiciones distintas."),
    ],
    links: [
      link("Movimiento no permitido", "solucion/movimiento-no-permitido"),
      link("Mover un bloque", "reglas/mover-bloque"),
      link("Reglas de XIMA", "reglas"),
    ],
    cta: { label: "Ver movimiento no permitido", path: "solucion/movimiento-no-permitido" },
    sources: ["F41", "F44"],
  },
  {
    slug: "solucion/movimiento-no-permitido",
    category: "solucion",
    title: "Movimiento no permitido en XIMA | Causas comunes y solucion",
    metaDescription:
      "Revisa por que XIMA puede no permitir un movimiento: turno, dados, tablero, altura, bloque especial o estado de la partida.",
    h1: "Movimiento no permitido",
    intro:
      "Cuando un movimiento no se puede ejecutar, la causa suele estar en una regla publica del tablero, del turno o del modo.",
    verified:
      "El juego valida movimientos antes de aplicarlos y puede bloquear acciones que no respetan estado de turno, destino, altura, dados o reglas especiales.",
    usage:
      "Empieza comprobando si es tu turno, si seleccionaste un bloque propio, si el destino esta en linea recta y si el modo exige dados.",
    caution:
      "No se documentan codigos internos, eventos de socket ni detalles que faciliten abuso del sistema online.",
    steps: [
      "Confirma que sea tu turno.",
      "Selecciona un bloque propio disponible.",
      "Revisa si la jugada intenta salir del tablero.",
      "Comprueba distancia y modo, sobre todo si hay dados.",
      "Si persiste, guarda una descripcion visible y contacta soporte.",
    ],
    examples: [
      "En Azar, un movimiento puede fallar si no coincide con los pasos indicados.",
      "Un bloque comun no debe tratarse como especial para ganar en la cima.",
    ],
    faqs: [
      faq("Debo enviar capturas a soporte?", "Puede ayudar una captura de la pantalla, pero nunca compartas contrasenas ni tokens."),
      faq("Este error significa que la partida esta rota?", "No siempre. Muchas veces indica que la jugada no cumple una regla visible."),
    ],
    links: [
      link("Jugada legal", "reglas/jugada-legal"),
      link("Dados en XIMA", "reglas/dados"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver jugada legal", path: "reglas/jugada-legal" },
    sources: ["F41", "F44"],
    structuredDataType: "HowTo",
  },
  {
    slug: "reglas/coordenadas",
    category: "reglas",
    title: "Coordenadas del tablero XIMA | Como leer casillas y notacion",
    metaDescription:
      "Guia para entender coordenadas del tablero XIMA, su relacion con casillas, notacion, replay y lectura de movimientos.",
    h1: "Coordenadas del tablero",
    intro:
      "Las coordenadas ayudan a ubicar casillas y a conectar lo que ocurre en el tablero con la anotacion y el replay.",
    verified:
      "El proyecto usa identificadores de casillas y notacion de movimiento en reglas, bots, replay y tablero de Unity.",
    usage:
      "Al revisar una partida, las coordenadas permiten comparar origen, destino, jugador y secuencia de movimiento sin depender solo de la imagen.",
    caution:
      "La forma exacta de mostrar todas las coordenadas debe alinearse con capturas oficiales antes de ampliar esta pagina.",
    examples: [
      "Una entrada del replay puede combinar jugador y notacion para resumir el movimiento.",
      "La cima aparece referida como una casilla especial en la documentacion de reglas.",
    ],
    faqs: [
      faq("Las coordenadas aparecen en todas las vistas?", "No necesariamente. Son mas importantes en anotacion, replay y explicaciones de tablero."),
      faq("Sirven para aprender reglas?", "Si. Ayudan a entender de donde sale y a donde llega un bloque."),
    ],
    links: [
      link("Sistema de anotacion", "sistema-de-anotacion"),
      link("Timeline del replay", "replay/timeline"),
      link("Tablero y casillas", "reglas/tablero-y-casillas"),
    ],
    cta: { label: "Ver anotacion", path: "sistema-de-anotacion" },
    sources: ["F08", "F38", "F41"],
  },
  {
    slug: "reglas/cima",
    category: "reglas",
    title: "La cima en XIMA | Objetivo del bloque especial",
    metaDescription:
      "Aprende que representa la cima en XIMA, por que es el objetivo central y como se relaciona con especial, rescate y victoria.",
    h1: "Cima",
    intro:
      "La cima es el punto objetivo del tablero: llegar con el bloque especial propio puede cerrar la partida.",
    verified:
      "Las reglas publicas indican que el bloque especial que llega a la cima gana la partida, y que el comun solo se relaciona con la cima en contexto de rescate.",
    usage:
      "La cima se debe estudiar junto con movimiento, altura, bloque especial y rescate, porque no todos los bloques pueden usarla de la misma forma.",
    caution:
      "Los casos de rescate necesitan ejemplos oficiales antes de convertirlos en diagramas publicos.",
    examples: [
      "Un especial que llega a la cima puede cumplir el objetivo principal.",
      "Un comun en la cima debe entenderse con la regla de rescate, no como objetivo normal.",
    ],
    faqs: [
      faq("La cima es una casilla normal?", "No. Es una casilla objetivo con reglas especiales."),
      faq("Siempre gana quien llega primero a la cima?", "La guia verificada habla del bloque especial propio llegando a la cima mediante una jugada valida."),
    ],
    links: [
      link("Objetivo del juego", "reglas/objetivo"),
      link("Bloque especial", "reglas/bloque-especial"),
      link("Rescate de bloques", "reglas/rescate"),
    ],
    cta: { label: "Ver objetivo", path: "reglas/objetivo" },
    sources: ["F08", "F41", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "reglas/objetivo",
    category: "reglas",
    title: "Objetivo de XIMA | Llevar el bloque especial a la cima",
    metaDescription:
      "Resumen oficial del objetivo de XIMA: jugar con bloques, avanzar por el tablero y llevar el especial a la cima.",
    h1: "Objetivo del juego",
    intro:
      "El objetivo central de XIMA es llevar el bloque especial propio a la cima mediante una jugada valida.",
    verified:
      "La base de conocimiento y las reglas publicas coinciden en que el especial y la cima son el eje de victoria mas importante.",
    usage:
      "Para aprender rapido, lee el objetivo antes de estudiar captura, rescate, dominacion, dados o ranking.",
    caution:
      "No se agregan aqui beneficios, historia ni estadisticas de uso que no esten respaldadas por documentos del proyecto.",
    examples: [
      "Un jugador puede usar bloques comunes para construir presencia y proteger rutas.",
      "El especial tiene restricciones propias y no debe confundirse con los bloques comunes.",
    ],
    faqs: [
      faq("Que debo lograr en XIMA?", "Llevar tu bloque especial a la cima del tablero."),
      faq("El objetivo cambia por modo?", "La forma de llegar puede cambiar por modo, pero el objetivo base se mantiene como referencia central."),
    ],
    links: [
      link("Que es XIMA", "que-es-xima"),
      link("Cima", "reglas/cima"),
      link("Como jugar XIMA", "como-jugar"),
    ],
    cta: { label: "Aprender como jugar", path: "como-jugar" },
    sources: ["F08", "F41", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "reglas/turnos",
    category: "reglas",
    title: "Turnos en XIMA | Incorporar, mover y respetar el orden",
    metaDescription:
      "Aprende como funcionan los turnos en XIMA y que puede hacer un jugador cuando le corresponde jugar.",
    h1: "Turnos en XIMA",
    intro:
      "El turno organiza cuando un jugador puede incorporar o mover un bloque dentro de una partida.",
    verified:
      "Las reglas publicas indican que cada jugador mueve una vez por turno y que en su turno puede incorporar un bloque nuevo o mover uno ya colocado.",
    usage:
      "Antes de interpretar una jugada como error, confirma si el turno pertenece al jugador correcto y si el modo esta en una fase compatible.",
    caution:
      "Los estados internos de temporizador, sockets y sincronizacion online no se explican como reglas publicas.",
    examples: [
      "Si no es tu turno, la accion puede no aplicarse aunque el destino parezca correcto.",
      "En modos con dados puede existir una fase previa relacionada con el lanzamiento.",
    ],
    faqs: [
      faq("Puedo jugar varias veces seguidas?", "La regla base indica una vez por turno."),
      faq("Turno y tiempo por turno son lo mismo?", "No. El turno es el orden de juego; el tiempo por turno es una configuracion de partida."),
    ],
    links: [
      link("Incorporar un bloque", "reglas/incorporar-bloque"),
      link("Tiempo por turno", "tutoriales/tiempo-por-turno"),
      link("Mover un bloque", "reglas/mover-bloque"),
    ],
    cta: { label: "Ver incorporar bloque", path: "reglas/incorporar-bloque" },
    sources: ["F41", "F43", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "tutoriales/jugar-modo-ciencia",
    category: "tutorial",
    title: "Como jugar Modo Ciencia en XIMA | Tutorial verificado",
    metaDescription:
      "Tutorial para empezar en Modo Ciencia de XIMA, elegir el modo, jugar sin dados y revisar la partida despues.",
    h1: "Como jugar Ciencia",
    intro:
      "Modo Ciencia se centra en decisiones de movimiento sin depender de dados para elegir los pasos.",
    verified:
      "La interfaz muestra Ciencia como modo disponible y la documentacion lo separa de Azar, Cienzar y Ciencia V/S Azar.",
    usage:
      "Usalo para practicar lectura de tablero, rutas, bloque especial y respuesta del rival con control directo sobre tus movimientos.",
    caution:
      "Esta guia no afirma estrategias ganadoras ni heuristicas de bot; solo explica el flujo visible para jugar.",
    steps: [
      "Abre crear partida, bot o el flujo donde aparezca Modo Ciencia.",
      "Selecciona Ciencia.",
      "Elige jugadores y tiempo si el flujo lo solicita.",
      "Inicia la partida.",
      "En cada turno, selecciona una jugada legal sin usar dados.",
      "Revisa historial o replay cuando la partida termine.",
    ],
    examples: [
      "Ciencia es util para practicar decisiones de posicion.",
      "Si quieres comparar con dados, revisa Modo Azar.",
    ],
    faqs: [
      faq("Ciencia usa dados?", "La documentacion lo presenta como modo sin dados para escoger el movimiento."),
      faq("Sirve para aprender reglas?", "Si. Al reducir el azar, ayuda a concentrarse en tablero y movimientos."),
    ],
    links: [
      link("Modo Ciencia", "ciencia"),
      link("Mover un bloque", "reglas/mover-bloque"),
      link("Como jugar Azar", "tutoriales/jugar-modo-azar"),
    ],
    cta: { label: "Ver Modo Ciencia", path: "ciencia" },
    sources: ["F08", "F10", "F11", "F39"],
  },
  {
    slug: "tutoriales/jugar-modo-azar",
    category: "tutorial",
    title: "Como jugar Modo Azar en XIMA | Dados y primeros pasos",
    metaDescription:
      "Aprende como iniciar una partida en Modo Azar de XIMA y como los dados se relacionan con el movimiento.",
    h1: "Como jugar Azar",
    intro:
      "Modo Azar incorpora dados al flujo de movimiento, por lo que combina reglas de tablero con resultado aleatorio.",
    verified:
      "La regla publica indica que, en modo con Azar, los pasos pueden estar indicados por los dados. La UI tambien expone Azar como modo.",
    usage:
      "Antes de mover, revisa el resultado disponible y busca una ruta legal que respete distancia, linea recta y tablero.",
    caution:
      "Los detalles finos de dados por variante deben validarse en partida antes de publicarse como ejemplos avanzados.",
    steps: [
      "Selecciona Azar en un flujo de partida compatible.",
      "Configura jugadores y tiempo si corresponde.",
      "Inicia la partida.",
      "Lanza o espera el resultado de dados cuando el modo lo requiera.",
      "Elige un movimiento legal compatible con el resultado.",
      "Usa replay para estudiar como influyo el azar.",
    ],
    examples: [
      "Un resultado de dados puede limitar cuantos pasos buscar.",
      "Una ruta compatible con Ciencia puede no servir en Azar si no coincide con los dados.",
    ],
    faqs: [
      faq("Azar elimina la estrategia?", "No. Los dados influyen, pero el jugador todavia debe encontrar jugadas legales."),
      faq("Donde veo mas sobre dados?", "Consulta la guia de Dados en XIMA y Lanzar dados."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Dados en XIMA", "reglas/dados"),
      link("Lanzar dados", "tutoriales/lanzar-dados"),
    ],
    cta: { label: "Ver dados", path: "reglas/dados" },
    sources: ["F08", "F42", "F43"],
  },
  {
    slug: "reglas/dados",
    category: "reglas",
    title: "Dados en XIMA | Como afectan al Modo Azar",
    metaDescription:
      "Guia sobre dados en XIMA: que esta verificado, como afectan el avance y que se debe confirmar antes de explicar variantes.",
    h1: "Dados en XIMA",
    intro:
      "Los dados forman parte de los modos con Azar y pueden determinar la cantidad de pasos disponibles.",
    verified:
      "La regla publica de movimiento menciona que, en modo con Azar, los pasos pueden ser los que indiquen los dados.",
    usage:
      "Despues de obtener el resultado, el jugador debe encontrar un movimiento legal que tambien respete linea recta, altura y tablero.",
    caution:
      "No se publican aqui formulas internas ni detalles de bots con dados; solo la relacion visible entre dados y movimiento.",
    examples: [
      "Si el dado exige una distancia concreta, una jugada de otra distancia puede fallar.",
      "Los dados no eliminan las restricciones de tablero ni de bloque especial.",
    ],
    faqs: [
      faq("Los dados solo aparecen en Azar?", "Aparecen en modos o variantes con Azar, segun el flujo elegido."),
      faq("Puedo ignorar los dados?", "En un modo con dados, el movimiento debe interpretarse junto con ese resultado."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Lanzar dados", "tutoriales/lanzar-dados"),
      link("Movimiento no permitido", "solucion/movimiento-no-permitido"),
    ],
    cta: { label: "Aprender a lanzar dados", path: "tutoriales/lanzar-dados" },
    sources: ["F42", "F27", "frontend/public/rules/es/xima-rules.json"],
  },
  {
    slug: "tutoriales/lanzar-dados",
    category: "tutorial",
    title: "Lanzar dados en XIMA | Tutorial para modos con Azar",
    metaDescription:
      "Aprende el flujo publico para lanzar dados en XIMA, leer el resultado y buscar una jugada valida en modos con Azar.",
    h1: "Lanzar dados",
    intro:
      "Lanzar dados es una accion asociada a modos con Azar y ayuda a definir los pasos del movimiento.",
    verified:
      "El proyecto contiene interfaz y scripts de dados, ademas de soporte de control por voz relacionado con acciones de juego.",
    usage:
      "Cuando el modo lo requiera, espera o ejecuta el lanzamiento y usa el resultado como condicion para tu movimiento.",
    caution:
      "Los textos exactos de botones pueden variar por idioma o vista; se deben revisar antes de tomar capturas finales.",
    steps: [
      "Entra a una partida en modo con Azar.",
      "Espera tu turno.",
      "Usa la accion visible de lanzar dados cuando este disponible.",
      "Lee el resultado.",
      "Elige un bloque y busca un destino legal compatible.",
      "Confirma el movimiento.",
    ],
    examples: [
      "Si el resultado limita pasos, primero piensa en rutas posibles antes de seleccionar destino.",
      "El control por voz puede convivir con acciones de juego, pero depende de permisos y configuracion.",
    ],
    faqs: [
      faq("Puedo lanzar dados fuera de mi turno?", "La accion depende del estado de la partida y del turno."),
      faq("Los dados garantizan movimiento?", "No. Tambien debe existir una jugada legal compatible."),
    ],
    links: [
      link("Dados en XIMA", "reglas/dados"),
      link("Control por voz", "control-por-voz"),
      link("Modo Azar", "azar"),
    ],
    cta: { label: "Ver Modo Azar", path: "azar" },
    sources: ["F42", "F27", "F43"],
  },
  {
    slug: "modos/cienzar-ciencia-y-azar",
    category: "modos",
    title: "Cienzar como modo hibrido | Ciencia y Azar en XIMA",
    metaDescription:
      "Pagina prudente sobre Cienzar como modo hibrido de XIMA, marcada para confirmacion antes de indexar.",
    h1: "Cienzar como modo hibrido",
    intro:
      "Cienzar aparece en el proyecto como un modo que combina elementos de Ciencia y Azar, pero su explicacion oficial necesita confirmacion.",
    verified:
      "La plataforma contiene referencias a Cienzar en interfaz, reglas internas, bots y estadisticas, y existe una pagina previa marcada noindex.",
    usage:
      "La descripcion publica debe limitarse a indicar que es un modo diferenciado y que puede mezclar decision y dados segun el flujo implementado.",
    caution:
      "No se deben publicar reglas finas, ejemplos ni promesas competitivas de Cienzar sin aprobacion del propietario.",
    confirmation:
      "Pendiente confirmar definicion oficial, flujo de dados, nombres publicos y casos de movimiento antes de indexar esta pagina.",
    examples: [
      "Cienzar se relaciona con Ciencia y Azar, pero no debe explicarse como simple suma de ambos sin validacion.",
      "Las estadisticas pueden mostrar Cienzar como modo, aunque su guia completa siga pendiente.",
    ],
    faqs: [
      faq("Esta pagina esta lista para Google?", "No. Se mantiene noindex hasta recibir confirmacion oficial."),
      faq("Puedo jugar Cienzar?", "La interfaz lo referencia, pero la documentacion publica completa debe confirmarse."),
    ],
    links: [
      link("Modo Cienzar", "cienzar"),
      link("Modo Ciencia", "ciencia"),
      link("Modo Azar", "azar"),
    ],
    cta: { label: "Ver modos", path: "modos-de-juego" },
    sources: ["F08", "F42"],
    status: "ownerConfirmation",
  },
  {
    slug: "modos/contrazar",
    category: "modos",
    title: "Contrazar en XIMA | Estado y confirmacion pendiente",
    metaDescription:
      "Conoce que se puede decir de Contrazar en XIMA sin inventar reglas: referencias reales, relacion con ranking y puntos pendientes.",
    h1: "Contrazar",
    intro:
      "Contrazar aparece como etiqueta de modo o estadistica en el proyecto, pero necesita definicion publica oficial.",
    verified:
      "El frontend muestra referencias a Contrazar en estadisticas, ranking y CIMAX, asociadas al entorno de Ciencia V/S Azar.",
    usage:
      "Hasta que exista definicion aprobada, debe tratarse como una categoria visible de datos, no como una regla nueva inventada.",
    caution:
      "No se publica como modo independiente indexable hasta confirmar nombre, reglas y relacion exacta con Ciencia V/S Azar.",
    confirmation:
      "Pendiente decidir si Contrazar es nombre publico, alias, submodo o lectura estadistica.",
    examples: [
      "Puede verse Contrazar en paneles de progreso.",
      "La guia enlaza con Ciencia V/S Azar porque es la relacion mas clara en fuentes actuales.",
    ],
    faqs: [
      faq("Contrazar ya tiene guia oficial?", "No. Esta pagina queda noindex hasta confirmacion."),
      faq("Por que existe la URL?", "Para reservar una explicacion controlada y evitar contenido inventado."),
    ],
    links: [
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
      link("CIMAX Contrazar", "estadisticas/cimax-contrazar"),
      link("Ranking Contrazar", "ranking/contrazar"),
    ],
    cta: { label: "Ver Ciencia V/S Azar", path: "modos/ciencia-vs-azar" },
    sources: ["F10", "F19", "F20", "F47"],
    status: "ownerConfirmation",
  },
  {
    slug: "tutoriales/crear-partida-publica",
    category: "tutorial",
    title: "Crear una partida publica en XIMA | Guia paso a paso",
    metaDescription:
      "Aprende como crear una partida publica en XIMA desde la interfaz de juego, eligiendo modo, jugadores y tiempo.",
    h1: "Crear partida publica",
    intro:
      "Una partida publica permite preparar un desafio visible para que otros jugadores puedan unirse desde los listados disponibles.",
    verified:
      "La plataforma tiene flujos de creacion, modo, jugadores, tiempo por turno y listados de desafios o partidas independientes.",
    usage:
      "Usa este flujo cuando quieras abrir una partida sin compartir una clave privada con un grupo concreto.",
    caution:
      "La disponibilidad real depende del estado de sesion, conexion y reglas activas del backend.",
    steps: [
      "Entra al lobby o a crear partida.",
      "Selecciona el tipo de juego online.",
      "Elige modo de juego.",
      "Configura numero de jugadores y tiempo por turno.",
      "Deja la partida sin clave privada si el flujo lo permite.",
      "Crea el desafio y espera jugadores.",
    ],
    examples: [
      "Una partida publica puede aparecer en listados de partidas independientes.",
      "Si quieres jugar solo con alguien especifico, revisa partida privada.",
    ],
    faqs: [
      faq("Publica significa sin restricciones internas?", "No. Sigue usando reglas de sesion, capacidad y estado de partida."),
      faq("Puedo cambiar el modo despues?", "La guia no confirma cambios posteriores; configura bien antes de crear."),
    ],
    links: [
      link("Crear partida privada", "tutoriales/crear-partida-privada"),
      link("Partidas independientes", "partidas/independientes"),
      link("Buscar partidas", "tutoriales/buscar-partidas"),
    ],
    cta: { label: "Ver partidas online", path: "partidas-online" },
    sources: ["F08", "F11", "F12", "F32"],
  },
  {
    slug: "tutoriales/crear-partida-privada",
    category: "tutorial",
    title: "Crear una partida privada en XIMA | Invitaciones y clave",
    metaDescription:
      "Guia para crear una partida privada en XIMA sin exponer seguridad interna: modo, jugadores, tiempo e invitaciones.",
    h1: "Crear partida privada",
    intro:
      "Una partida privada sirve para jugar con personas concretas y controlar el acceso desde el flujo visible del producto.",
    verified:
      "El backend contempla partidas con contrasena y la UI tiene flujos de invitacion, amigos y union a partidas privadas.",
    usage:
      "Configura la partida, comparte solo la informacion necesaria con tus invitados y evita publicar claves en canales abiertos.",
    caution:
      "Esta guia no muestra detalles de almacenamiento, hash, validacion interna ni seguridad privada.",
    steps: [
      "Abre crear partida.",
      "Elige modo, jugadores y tiempo.",
      "Activa o usa la opcion privada cuando este disponible.",
      "Define la informacion de acceso visible para tus invitados.",
      "Invita amigos o comparte la clave por un canal seguro.",
      "Espera que los jugadores entren antes de iniciar.",
    ],
    examples: [
      "Una privada es util para jugar con amigos agregados.",
      "Si no necesitas controlar acceso, una publica puede ser mas simple.",
    ],
    faqs: [
      faq("Debo publicar la contrasena?", "No. Compartela solo con quienes deban unirse."),
      faq("Puedo invitar amigos?", "El sistema de Amigos incluye invitaciones y union a partidas cuando el estado lo permite."),
    ],
    links: [
      link("Contrasena de partida", "tutoriales/contrasena-de-partida"),
      link("Invitar amigo a partida", "tutoriales/invitar-amigo-a-partida"),
      link("Unirse a partida privada", "tutoriales/unirse-partida-privada"),
    ],
    cta: { label: "Ver contrasena", path: "tutoriales/contrasena-de-partida" },
    sources: ["F08", "F11", "F12", "F32"],
  },
  {
    slug: "tutoriales/contrasena-de-partida",
    category: "tutorial",
    title: "Contrasena de partida en XIMA | Uso seguro para privadas",
    metaDescription:
      "Aprende para que sirve la contrasena de partida privada en XIMA y que no debes compartir publicamente.",
    h1: "Contrasena de partida",
    intro:
      "La contrasena de partida ayuda a limitar el acceso a una partida privada o protegida.",
    verified:
      "El backend reconoce partidas con contrasena y devuelve mensajes publicos cuando una partida requiere clave o la clave no coincide.",
    usage:
      "Usa la contrasena solo como dato de acceso entre jugadores invitados; no la incluyas en foros, soporte publico ni capturas abiertas.",
    caution:
      "No se explican detalles de seguridad interna, almacenamiento ni validacion tecnica de claves.",
    steps: [
      "Crea o recibe una partida privada.",
      "Copia la contrasena solo desde el canal autorizado.",
      "Al unirte, escribe la contrasena solicitada.",
      "Si falla, revisa mayusculas, espacios y que sea la partida correcta.",
      "Nunca envies contrasenas de cuenta ni tokens a soporte.",
    ],
    examples: [
      "Un mensaje puede indicar que el partido tiene contrasena y debes escribirla.",
      "Si la clave no coincide, el acceso a esa partida puede rechazarse.",
    ],
    faqs: [
      faq("Es la misma contrasena de mi cuenta?", "No. No uses ni compartas la contrasena de tu cuenta."),
      faq("Soporte necesita mi clave?", "No. Para soporte basta describir el problema sin revelar secretos."),
    ],
    links: [
      link("Crear partida privada", "tutoriales/crear-partida-privada"),
      link("Unirse a partida privada", "tutoriales/unirse-partida-privada"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Unirse a privada", path: "tutoriales/unirse-partida-privada" },
    sources: ["F12", "F32"],
  },
  {
    slug: "tutoriales/seleccionar-modo",
    category: "tutorial",
    title: "Seleccionar modo al crear partida XIMA | Ciencia, Azar y mas",
    metaDescription:
      "Guia para elegir modo al crear una partida en XIMA: Ciencia, Azar, Cienzar, Ciencia V/S Azar o FreeBox segun el flujo.",
    h1: "Seleccionar modo al crear partida",
    intro:
      "El modo define como se interpretan las decisiones de movimiento y que reglas adicionales pueden activarse.",
    verified:
      "La interfaz de creacion y lobby muestra modos como Ciencia, Azar, Cienzar, Ciencia V/S Azar y FreeBox segun el contexto.",
    usage:
      "Elige Ciencia para practicar decision directa, Azar para jugar con dados, o revisa las guias de modos si no conoces las diferencias.",
    caution:
      "Cienzar y algunos nombres asociados necesitan confirmacion oficial antes de ampliarse con reglas finas.",
    steps: [
      "Abre crear partida.",
      "Localiza la seccion de modo de juego.",
      "Compara las opciones visibles.",
      "Selecciona el modo deseado.",
      "Continua con jugadores y tiempo.",
      "Crea la partida cuando la configuracion este completa.",
    ],
    examples: [
      "Ciencia prioriza decisiones sin dados.",
      "Azar usa dados como parte del flujo de movimiento.",
    ],
    faqs: [
      faq("Puedo cambiar de modo en medio de la partida?", "La guia no confirma cambios despues de crear; selecciona bien antes de iniciar."),
      faq("Que modo conviene para aprender?", "Ciencia suele ser mas directo para estudiar tablero; Azar ayuda a practicar con dados."),
    ],
    links: [
      link("Modos de juego", "modos-de-juego"),
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
      link("FreeBox", "modos/freebox"),
    ],
    cta: { label: "Ver modos", path: "modos-de-juego" },
    sources: ["F11", "F12", "F39"],
  },
  {
    slug: "tutoriales/tiempo-por-turno",
    category: "tutorial",
    title: "Tiempo por turno en XIMA | Configuracion de partida",
    metaDescription:
      "Aprende que significa el tiempo por turno en XIMA y como configurarlo al crear partidas online o contra bot.",
    h1: "Tiempo por turno",
    intro:
      "El tiempo por turno define el margen disponible para actuar cuando una partida usa temporizador.",
    verified:
      "Las pantallas de crear partida y jugar con bot incluyen opciones de tiempo por turno, mostradas como minutos.",
    usage:
      "Elige un tiempo que permita pensar sin alargar demasiado la partida. Para aprender, conviene evitar presion excesiva.",
    caution:
      "La duracion exacta disponible depende del flujo y de las opciones visibles en la version actual.",
    steps: [
      "Abre el flujo de crear partida o jugar con bot.",
      "Busca la seccion Tiempo por turno.",
      "Elige una opcion de minutos.",
      "Revisa que el resto de la configuracion este completa.",
      "Inicia la partida.",
    ],
    examples: [
      "Un tiempo corto aumenta presion y exige conocer reglas.",
      "Un tiempo mas amplio puede ayudar al estudiar movimientos y cima.",
    ],
    faqs: [
      faq("Tiempo por turno es tiempo total de partida?", "No. Se refiere al margen por jugada o turno, no al historial completo."),
      faq("Existe en partidas con bot?", "La pantalla de bot incluye configuracion de tiempo por turno."),
    ],
    links: [
      link("Turnos en XIMA", "reglas/turnos"),
      link("Crear una partida", "tutoriales/crear-partida"),
      link("Jugar con bot", "tutoriales/jugar-con-bot"),
    ],
    cta: { label: "Ver turnos", path: "reglas/turnos" },
    sources: ["F11", "F12", "F13", "F32"],
  },
  {
    slug: "tutoriales/numero-de-jugadores",
    category: "tutorial",
    title: "Numero de jugadores en XIMA | Configurar una partida",
    metaDescription:
      "Guia para elegir numero de jugadores en XIMA al crear partidas, jugar con bot o preparar modos compatibles.",
    h1: "Numero de jugadores",
    intro:
      "El numero de jugadores define cuantas personas o bots participan en una partida compatible.",
    verified:
      "La UI de creacion y bot permite seleccionar cantidades de jugadores u oponentes, y el backend normaliza tamanos de partida.",
    usage:
      "Para aprender, una partida 1 contra 1 facilita leer turnos. Con mas jugadores aumenta la interaccion del tablero.",
    caution:
      "No todas las combinaciones de modo, bot, local o torneo tienen necesariamente las mismas opciones visibles.",
    steps: [
      "Abre el flujo de partida.",
      "Selecciona el modo.",
      "Elige el numero de jugadores disponible.",
      "Configura tiempo y dificultad si aplica.",
      "Inicia o crea la partida.",
    ],
    examples: [
      "En bot puede elegirse uno, dos o tres rivales bot segun la pantalla.",
      "En partidas online la capacidad controla cuantos jugadores deben entrar antes de jugar.",
    ],
    faqs: [
      faq("Mas jugadores cambia las reglas base?", "El objetivo y movimientos se mantienen, pero cambia el orden y la presion del tablero."),
      faq("Puedo jugar solo?", "Existen flujos de entrenamiento como bot, FreeBox y puzzles, segun el caso."),
    ],
    links: [
      link("Crear partida", "tutoriales/crear-partida"),
      link("Bots de XIMA", "bots"),
      link("Torneos", "torneos"),
    ],
    cta: { label: "Crear partida", path: "tutoriales/crear-partida" },
    sources: ["F11", "F12", "F13", "F32"],
  },
  {
    slug: "partidas/independientes",
    category: "partidas",
    title: "Partidas independientes en XIMA | Que son y como encontrarlas",
    metaDescription:
      "Conoce las partidas independientes de XIMA, su relacion con el lobby, crear partida y buscar desafios online.",
    h1: "Partidas independientes",
    intro:
      "Las partidas independientes agrupan desafios creados fuera de un flujo de torneo oficial o sala especifica.",
    verified:
      "El lobby y la interfaz de busqueda incluyen referencias a desafios y partidas independientes creadas por jugadores.",
    usage:
      "Usalas cuando quieres jugar online sin depender de un torneo programado o de una invitacion privada.",
    caution:
      "La terminologia final entre partida, desafio y torneo debe mantenerse consistente con la UI visible.",
    examples: [
      "Una partida creada por un jugador puede aparecer como desafio disponible.",
      "El boton Unirse usa el flujo de partidas independientes cuando aplica.",
    ],
    screenshots: [],
    faqs: [
      faq("Son lo mismo que torneos?", "No necesariamente. La documentacion interna pide diferenciar terminologia con cuidado."),
      faq("Se pueden buscar?", "Si. El producto tiene vistas para buscar o actualizar partidos disponibles."),
    ],
    links: [
      link("Buscar partidas", "tutoriales/buscar-partidas"),
      link("Crear partida publica", "tutoriales/crear-partida-publica"),
      link("Lobby", "lobby"),
    ],
    cta: { label: "Buscar partidas", path: "tutoriales/buscar-partidas" },
    sources: ["F10", "F11", "F12", "F32"],
  },
  {
    slug: "tutoriales/buscar-partidas",
    category: "tutorial",
    title: "Buscar partidas en XIMA | Encontrar desafios disponibles",
    metaDescription:
      "Aprende como buscar partidas disponibles en XIMA desde el lobby y los listados de desafios creados por jugadores.",
    h1: "Buscar partidas",
    intro:
      "Buscar partidas permite encontrar desafios disponibles para unirse sin crear una partida nueva.",
    verified:
      "La interfaz contiene textos como Buscar partidos, Actualizar partidos, Unirse a y filtros o listados de desafios.",
    usage:
      "Revisa el modo, jugadores unidos, disponibilidad y estado antes de entrar a una partida.",
    caution:
      "Una partida puede llenarse, expirar o requerir condiciones adicionales antes de entrar.",
    steps: [
      "Entra al lobby o a la vista de buscar partidos.",
      "Actualiza la lista si es necesario.",
      "Revisa los datos visibles de cada tarjeta.",
      "Elige una partida compatible con lo que quieres jugar.",
      "Pulsa Unirse cuando este disponible.",
    ],
    examples: [
      "Puedes buscar desafios creados por otros jugadores.",
      "Si no hay partidas, crear una publica puede ser el siguiente paso.",
    ],
    faqs: [
      faq("Por que no veo partidas?", "Puede no haber desafios disponibles o el filtro puede estar limitando la lista."),
      faq("Unirse inicia de inmediato?", "Depende de capacidad, estado y flujo de la partida."),
    ],
    links: [
      link("Partidas independientes", "partidas/independientes"),
      link("Crear partida publica", "tutoriales/crear-partida-publica"),
      link("Partidas online", "partidas-online"),
    ],
    cta: { label: "Ver partidas online", path: "partidas-online" },
    sources: ["F10", "F12", "F32"],
  },
  {
    slug: "interfaz/menu-principal",
    category: "interfaz",
    title: "Menu principal de XIMA | Lobby, Aprender y secciones",
    metaDescription:
      "Guia del menu principal de XIMA: Lobby, Aprender, Historial, Estadisticas, Ajustes, Tienda, Amigos y Soporte.",
    h1: "Menu principal del juego",
    intro:
      "El menu principal conecta las areas de juego, aprendizaje, progreso, comunidad, tienda y soporte de XIMA.",
    verified:
      "GameLayout muestra accesos como Lobby, Aprender, Historial, Estadisticas, Ajustes, Tienda, Ver partidos, Amigos, Soporte y Noticias.",
    usage:
      "Usa el menu para cambiar de seccion sin perder la orientacion entre jugar, revisar partidas y aprender reglas.",
    caution:
      "En movil el menu puede reorganizarse para adaptarse al espacio disponible.",
    examples: [
      "Aprender abre guias y reglas.",
      "Historial permite revisar partidas finalizadas y abrir replay cuando existe.",
    ],
    faqs: [
      faq("El menu es igual en escritorio y movil?", "No siempre. En movil puede aparecer como navegacion inferior o panel adaptado."),
      faq("Aprender esta dentro del menu?", "Si. Hay un acceso visible a Aprender."),
    ],
    links: [
      link("Lobby", "lobby"),
      link("Boton Aprender", "interfaz/boton-aprender"),
      link("Menu movil", "movil/menu-inferior"),
    ],
    cta: { label: "Ver Lobby", path: "lobby" },
    sources: ["F02", "F10"],
  },
  {
    slug: "interfaz/boton-aprender",
    category: "interfaz",
    title: "Boton Aprender en XIMA | Acceso a guias y reglas",
    metaDescription:
      "Conoce para que sirve el boton Aprender en XIMA y como conecta con reglas, videos, glosario y guias oficiales.",
    h1: "Boton Aprender",
    intro:
      "El boton Aprender lleva a la seccion donde XIMA organiza guias, reglas y contenido educativo.",
    verified:
      "El menu y la pagina Learn contienen acceso a Aprender, videos oficiales, guias esenciales y paginas SEO de ayuda.",
    usage:
      "Usa Aprender cuando necesites entender reglas, modos, historial, replay, soporte o terminos del juego.",
    caution:
      "Las paginas con confirmacion pendiente se marcan de forma separada para no mezclar reglas oficiales con borradores.",
    examples: [
      "Si no sabes que significa CIMAX, entra por Aprender y luego Estadisticas.",
      "Si una jugada falla, Aprender enlaza con solucion de problemas.",
    ],
    faqs: [
      faq("Aprender cambia mi partida?", "No. Es una seccion de consulta y formacion."),
      faq("Tiene videos?", "La portada de Aprender incluye tutoriales en video oficiales visibles en el proyecto."),
    ],
    links: [
      link("Aprender XIMA", ""),
      link("Glosario", "glosario"),
      link("Solucion de problemas", "solucion-de-problemas"),
    ],
    cta: { label: "Abrir glosario", path: "glosario" },
    sources: ["F02", "F03", "F04"],
  },
  {
    slug: "interfaz/volver-al-lobby",
    category: "interfaz",
    title: "Volver al lobby en XIMA | Navegacion desde Aprender",
    metaDescription:
      "Aprende para que sirve Volver al lobby en XIMA y como regresar desde Aprender, tienda, bot, ajustes o replay.",
    h1: "Boton Volver al lobby",
    intro:
      "Volver al lobby es una accion de navegacion para regresar al centro principal de XIMA.",
    verified:
      "Varias pantallas incluyen textos como VOLVER AL LOBBY o Volver al lobby, entre ellas bot, ajustes, tienda y vistas de juego.",
    usage:
      "Usalo cuando termines de consultar una guia, configurar una opcion o preparar una partida y quieras regresar al punto central.",
    caution:
      "La posicion exacta del boton puede variar por pantalla, idioma y dispositivo.",
    examples: [
      "Desde Aprender puedes volver para crear partida.",
      "Desde jugar con bot puedes regresar al lobby antes de iniciar otra configuracion.",
    ],
    faqs: [
      faq("Volver al lobby cierra sesion?", "No. Cerrar sesion es una accion diferente del menu."),
      faq("Aparece siempre igual?", "Puede cambiar entre mayusculas y minusculas segun la vista."),
    ],
    links: [
      link("Lobby", "lobby"),
      link("Menu principal", "interfaz/menu-principal"),
      link("Jugar con bot", "tutoriales/jugar-con-bot"),
    ],
    cta: { label: "Ver menu principal", path: "interfaz/menu-principal" },
    sources: ["F03", "F10", "F13", "F25"],
  },
  {
    slug: "interfaz/notificaciones-menu",
    category: "interfaz",
    title: "Notificaciones del menu XIMA | Avisos visibles",
    metaDescription:
      "Guia sobre notificaciones visibles del menu de XIMA: noticias, amigos, soporte y contadores sin exponer datos privados.",
    h1: "Notificaciones del menu",
    intro:
      "El menu puede mostrar avisos o contadores para llamar la atencion sobre secciones con actividad.",
    verified:
      "La interfaz contiene indicadores de notificaciones y contadores asociados a secciones como Noticias y areas sociales.",
    usage:
      "Revisa el aviso desde la seccion correspondiente y evita asumir que todos los contadores significan lo mismo.",
    caution:
      "No se publican reglas internas de calculo, consultas privadas ni datos personales asociados a notificaciones.",
    confirmation:
      "Conviene confirmar la politica publica de cada contador antes de documentarlo con capturas.",
    examples: [
      "Un contador junto a Noticias puede indicar elementos pendientes de revisar.",
      "Amigos puede mostrar actividad relacionada con solicitudes o invitaciones.",
    ],
    faqs: [
      faq("Un contador muestra datos privados?", "La pagina publica no debe exponer datos personales; solo explica la funcion visible."),
      faq("Debo actuar siempre?", "No necesariamente. Revisa la seccion indicada para entender el aviso."),
    ],
    links: [
      link("Noticias", "noticias"),
      link("Amigos", "amigos"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver Amigos", path: "amigos" },
    sources: ["F02", "F10"],
    status: "partial",
  },
  {
    slug: "movil/menu-inferior",
    category: "movil",
    title: "Menu movil de XIMA | Navegacion inferior y accesos",
    metaDescription:
      "Aprende como se adapta el menu de XIMA en movil, con accesos principales, lobby, cerrar sesion y secciones del juego.",
    h1: "Menu movil",
    intro:
      "En pantallas moviles, XIMA adapta la navegacion para que los accesos principales sean utilizables en menos espacio.",
    verified:
      "GameLayout contiene clases y condiciones para vista movil, navegacion inferior, botones compactos e iconos de secciones.",
    usage:
      "Desplazate por la barra o panel visible y prioriza los accesos de juego, Aprender, ajustes, tienda o cierre de sesion segun necesites.",
    caution:
      "La distribucion exacta puede cambiar por orientacion, ancho de pantalla y dispositivo.",
    examples: [
      "En portrait puede aparecer una navegacion inferior.",
      "Algunas secciones desde lobby abren paneles adaptados a movil.",
    ],
    faqs: [
      faq("El menu movil tiene las mismas secciones?", "Tiene acceso a secciones principales, pero puede reorganizar su forma visual."),
      faq("Puedo usar Aprender en movil?", "Si. Aprender y sus guias estan pensadas para rutas publicas y protegidas."),
    ],
    links: [
      link("Compatibilidad movil", "compatibilidad-movil"),
      link("Menu principal", "interfaz/menu-principal"),
      link("Replay en movil", "replay/movil"),
    ],
    cta: { label: "Ver compatibilidad movil", path: "compatibilidad-movil" },
    sources: ["F02", "F10"],
  },
  {
    slug: "movil/descargar-app",
    category: "movil",
    title: "Descargar app movil de XIMA | Estado pendiente",
    metaDescription:
      "Pagina de estado sobre app movil de XIMA: que se puede afirmar desde el proyecto y que requiere confirmacion oficial.",
    h1: "Descargar app movil",
    intro:
      "La informacion sobre una app movil distribuida oficialmente necesita confirmacion del propietario antes de publicarse.",
    verified:
      "El proyecto tiene compatibilidad movil web y referencias legales/generales, pero no se debe inventar una tienda o canal de descarga.",
    usage:
      "Hasta confirmar distribucion oficial, la recomendacion publica es usar la experiencia web compatible desde juegoxima.com.",
    caution:
      "No se publican enlaces de descarga, plataformas, precios ni disponibilidad sin fuente oficial.",
    confirmation:
      "Pendiente confirmar si existe app oficial, plataformas soportadas, URL de descarga y texto legal.",
    examples: [
      "La web puede usarse en navegador movil si el dispositivo es compatible.",
      "Una pagina de descarga solo debe indexarse cuando exista canal oficial.",
    ],
    faqs: [
      faq("Hay app oficial disponible?", "No se confirma en esta guia. Requiere aprobacion del propietario."),
      faq("Puedo jugar en movil?", "Consulta compatibilidad movil para la experiencia web."),
    ],
    links: [
      link("Compatibilidad movil", "compatibilidad-movil"),
      link("Menu movil", "movil/menu-inferior"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver compatibilidad", path: "compatibilidad-movil" },
    sources: ["F02", "F29"],
    status: "ownerConfirmation",
  },
  {
    slug: "historial",
    category: "replay",
    title: "Historial de partidas XIMA | Resultados, filtros y replay",
    metaDescription:
      "Aprende que muestra el historial de partidas de XIMA: resultados, jugadores, modo, fecha, filtros y acceso a replay.",
    h1: "Historial de partidas",
    intro:
      "El historial recopila partidas finalizadas y datos visibles para revisar tu actividad en XIMA.",
    verified:
      "La documentacion interna confirma resultado, modo, jugadores, fecha, datos de rendimiento, paginacion, filtros y acceso a replay cuando existe.",
    usage:
      "Usa el historial para estudiar partidas anteriores, filtrar resultados y abrir una repeticion si la partida tiene replay guardado.",
    caution:
      "No todas las partidas tienen necesariamente el mismo nivel de datos o replay disponible.",
    examples: [
      "Puedes filtrar por resultado o modo para revisar patrones.",
      "El boton de replay se desactiva cuando no hay repeticion disponible.",
    ],
    faqs: [
      faq("El historial muestra todas mis partidas?", "Muestra partidas registradas; la disponibilidad depende del registro de la partida."),
      faq("Puedo abrir replay desde historial?", "Si, cuando la partida tiene replay disponible."),
    ],
    links: [
      link("Actualizar historial", "tutoriales/actualizar-historial"),
      link("Ver replay", "tutoriales/ver-replay"),
      link("Estadisticas", "estadisticas"),
    ],
    cta: { label: "Ver replay", path: "tutoriales/ver-replay" },
    sources: ["F08", "F12", "F18", "F33"],
  },
  {
    slug: "tutoriales/actualizar-historial",
    category: "tutorial",
    title: "Actualizar historial en XIMA | Refrescar partidas registradas",
    metaDescription:
      "Aprende como usar Actualizar historial en XIMA para refrescar tus partidas, filtros y datos visibles.",
    h1: "Actualizar historial",
    intro:
      "Actualizar historial permite solicitar datos recientes de partidas registradas en la vista de historial.",
    verified:
      "La interfaz contiene el texto Actualizar historial y opciones de filtros, paginacion y busqueda dentro del historial.",
    usage:
      "Usalo cuando acabas de terminar una partida o cambias filtros y quieres comprobar si la lista refleja la informacion mas reciente.",
    caution:
      "Actualizar no crea datos que no existan; si una partida no quedo registrada, puede seguir sin aparecer.",
    steps: [
      "Abre Historial.",
      "Revisa los filtros activos.",
      "Pulsa Actualizar historial.",
      "Espera a que la lista termine de cargar.",
      "Comprueba resultado, modo y replay disponible.",
    ],
    examples: [
      "Despues de una partida, refrescar ayuda a buscarla en la lista.",
      "Si un filtro esta activo, la partida puede no aparecer hasta cambiarlo.",
    ],
    faqs: [
      faq("Actualizar historial recupera replays faltantes?", "No garantiza que exista replay; solo refresca los datos disponibles."),
      faq("Por que no veo una partida?", "Puede depender de filtros, registro, conexion o disponibilidad de datos."),
    ],
    links: [
      link("Historial de partidas", "historial"),
      link("No hay replay guardado", "solucion/no-hay-replay"),
      link("Ver replay", "tutoriales/ver-replay"),
    ],
    cta: { label: "Ver historial", path: "historial" },
    sources: ["F12", "F18"],
  },
  {
    slug: "tutoriales/ver-replay",
    category: "tutorial",
    title: "Ver replay en XIMA | Abrir una repeticion de partida",
    metaDescription:
      "Guia paso a paso para ver un replay en XIMA desde historial, perfil de amigo o replays destacados cuando esta disponible.",
    h1: "Ver replay",
    intro:
      "Ver replay permite reproducir una partida registrada para estudiar movimientos, timeline y resultado.",
    verified:
      "Historial, Ver partidos y perfil de amigo pueden abrir replay cuando la partida tiene repeticion disponible.",
    usage:
      "Busca una partida con replay habilitado, abre la repeticion y usa controles para pausar, reiniciar o avanzar por la timeline.",
    caution:
      "El acceso puede depender de permisos, relacion con la partida y disponibilidad del registro.",
    steps: [
      "Abre Historial, Ver partidos o un perfil compatible.",
      "Localiza una partida con replay disponible.",
      "Pulsa Ver repeticion, Reproducir o el boton de replay visible.",
      "Espera la carga del tablero.",
      "Usa controles de replay para analizar la secuencia.",
    ],
    examples: [
      "En perfil de amigo puede aparecer Reproducir si el match tiene replay.",
      "En Ver partidos aparece Ver repeticion para replays destacados disponibles.",
    ],
    faqs: [
      faq("Que hago si el boton esta desactivado?", "Consulta la guia No hay replay guardado."),
      faq("Puedo retroceder un paso?", "La UI indica que para volver atras por ahora se usa Reiniciar."),
    ],
    links: [
      link("Controles de replay", "replay/controles"),
      link("No hay replay guardado", "solucion/no-hay-replay"),
      link("Replays destacados", "replays-destacados"),
    ],
    cta: { label: "Ver controles", path: "replay/controles" },
    sources: ["F12", "F17", "F18", "F22", "F33"],
  },
  {
    slug: "replay/pausar-reproducir",
    category: "replay",
    title: "Pausar y reproducir replay en XIMA | Control de analisis",
    metaDescription:
      "Aprende a usar pausar y reproducir en el replay de XIMA para estudiar movimientos, timeline y ritmo de partida.",
    h1: "Pausar y reproducir replay",
    intro:
      "Pausar y reproducir controla el avance automatico del replay mientras revisas una partida.",
    verified:
      "La UI de replay alterna entre etiquetas de reproducir y pausa, junto a contador de movimientos, velocidad y timeline.",
    usage:
      "Pausa cuando quieras estudiar una posicion y reproduce cuando quieras continuar hasta el siguiente tramo de la partida.",
    caution:
      "Si el replay no esta listo o ya llego al final, el control puede estar deshabilitado.",
    steps: [
      "Abre un replay disponible.",
      "Espera a que el tablero indique que esta listo.",
      "Pulsa Reproducir para avanzar.",
      "Pulsa Pausar para detener el avance.",
      "Consulta la timeline para ubicar el movimiento actual.",
    ],
    examples: [
      "Puedes pausar antes de una captura para estudiar la columna.",
      "Puedes reproducir a mayor velocidad si solo quieres ver el flujo general.",
    ],
    faqs: [
      faq("Pausar cambia el resultado?", "No. Solo controla la visualizacion del replay."),
      faq("Puedo usarlo en movil?", "El replay tiene ajustes de vista movil, pero el espacio de pantalla cambia."),
    ],
    links: [
      link("Velocidad de replay", "replay/velocidad"),
      link("Timeline del replay", "replay/timeline"),
      link("Replay en movil", "replay/movil"),
    ],
    cta: { label: "Ver velocidad", path: "replay/velocidad" },
    sources: ["F12", "F33"],
  },
  {
    slug: "replay/reiniciar",
    category: "replay",
    title: "Reiniciar replay en XIMA | Volver al inicio de la repeticion",
    metaDescription:
      "Aprende para que sirve Reiniciar en el replay de XIMA y cuando usarlo para volver al inicio de una partida reproducida.",
    h1: "Reiniciar replay",
    intro:
      "Reiniciar replay vuelve a cargar la repeticion desde un estado inicial para revisar la secuencia otra vez.",
    verified:
      "La interfaz de replay incluye una accion de reinicio y mensajes de estado como reiniciando tablero.",
    usage:
      "Usalo cuando quieras volver atras, repetir una secuencia o reconstruir el tablero desde el principio.",
    caution:
      "La propia UI indica que para volver atras por ahora se usa Reiniciar, por lo que no debe prometerse retroceso paso a paso.",
    steps: [
      "Abre un replay.",
      "Avanza hasta la zona que quieras analizar.",
      "Pulsa Reiniciar cuando necesites volver al inicio.",
      "Espera a que el tablero termine de cargar.",
      "Reproduce o salta por la timeline de nuevo.",
    ],
    examples: [
      "Si avanzaste demasiado, reiniciar permite repetir el tramo.",
      "Antes de explicar una jugada en video, reiniciar ayuda a mostrarla desde cero.",
    ],
    faqs: [
      faq("Reiniciar borra el historial?", "No. Solo reinicia la visualizacion del replay."),
      faq("Es lo mismo que cerrar replay?", "No. Cerrar sale del modal; reiniciar conserva el replay abierto."),
    ],
    links: [
      link("Controles de replay", "replay/controles"),
      link("Saltar al final", "replay/saltar-final"),
      link("Timeline del replay", "replay/timeline"),
    ],
    cta: { label: "Ver controles", path: "replay/controles" },
    sources: ["F12", "F33"],
  },
  {
    slug: "replay/saltar-final",
    category: "replay",
    title: "Saltar al final del replay XIMA | Revisar resultado rapido",
    metaDescription:
      "Guia para usar saltar al final en replay de XIMA y revisar rapidamente el cierre de una partida registrada.",
    h1: "Saltar al final del replay",
    intro:
      "Saltar al final permite avanzar la repeticion hasta su ultimo tramo cuando quieres revisar el desenlace.",
    verified:
      "El replay maneja pasos, total de pasos y acciones para avanzar hasta estados posteriores de la repeticion.",
    usage:
      "Usa esta funcion cuando el objetivo sea verificar el resultado, el ultimo movimiento o el cierre de una secuencia.",
    caution:
      "Para aprendizaje detallado, saltar al final puede ocultar decisiones intermedias importantes.",
    steps: [
      "Abre un replay con pasos disponibles.",
      "Comprueba que la repeticion este lista.",
      "Usa la accion de avanzar o reproducir hasta el final.",
      "Revisa el ultimo estado del tablero.",
      "Reinicia si necesitas estudiar la ruta completa.",
    ],
    examples: [
      "Sirve para confirmar quien cerro la partida.",
      "No sustituye el analisis de timeline si quieres aprender la secuencia.",
    ],
    faqs: [
      faq("Saltar al final modifica el replay?", "No. Solo cambia la posicion de visualizacion."),
      faq("Puedo volver a ver desde el inicio?", "Si. Usa Reiniciar replay."),
    ],
    links: [
      link("Reiniciar replay", "replay/reiniciar"),
      link("Timeline del replay", "replay/timeline"),
      link("Ver replay", "tutoriales/ver-replay"),
    ],
    cta: { label: "Ver timeline", path: "replay/timeline" },
    sources: ["F12", "F33"],
  },
  {
    slug: "replay/camara-libre",
    category: "replay",
    title: "Camara libre en replay XIMA | Ver el tablero desde otro angulo",
    metaDescription:
      "Aprende que significa camara libre en el replay de XIMA y como ayuda a revisar posiciones del tablero 3D.",
    h1: "Camara libre en replay",
    intro:
      "La camara libre ayuda a mirar el tablero desde otro angulo durante la repeticion de una partida.",
    verified:
      "El replay muestra una etiqueta de camara libre y el proyecto contiene controles de camara para la experiencia 3D.",
    usage:
      "Usala para inspeccionar alturas, columnas, cima o zonas del tablero que no se entienden bien desde la vista inicial.",
    caution:
      "Mover la camara no altera los movimientos del replay ni el resultado de la partida.",
    examples: [
      "Al estudiar una captura, cambiar angulo puede aclarar que bloque esta encima.",
      "En movil el espacio para manipular camara puede ser menor.",
    ],
    faqs: [
      faq("Camara libre cambia la jugada?", "No. Solo cambia la visualizacion."),
      faq("Es util para reglas de altura?", "Si. Puede ayudar a distinguir niveles del tablero."),
    ],
    links: [
      link("Seguimiento de camara", "replay/seguimiento-camara"),
      link("Tablero y casillas", "reglas/tablero-y-casillas"),
      link("Replay en movil", "replay/movil"),
    ],
    cta: { label: "Ver seguimiento", path: "replay/seguimiento-camara" },
    sources: ["F12", "F45"],
  },
  {
    slug: "replay/seguimiento-camara",
    category: "replay",
    title: "Seguimiento de camara en replay XIMA | Activar y desactivar",
    metaDescription:
      "Conoce el seguimiento de camara en replay de XIMA y su relacion con ajustes, vista 3D y analisis de movimientos.",
    h1: "Seguimiento de camara en replay",
    intro:
      "El seguimiento de camara ayuda a mantener la vista orientada durante la reproduccion de movimientos.",
    verified:
      "La UI de replay incluye un control de seguimiento de camara y ajustes del proyecto contemplan opciones relacionadas con camara.",
    usage:
      "Activalo si quieres que la vista acompanhe mejor la accion; desactivalo si prefieres inspeccionar manualmente.",
    caution:
      "La disponibilidad puede depender de la vista, estado del replay y dispositivo.",
    steps: [
      "Abre un replay.",
      "Busca el control de seguimiento de camara.",
      "Activalo para que la camara acompanhe la reproduccion.",
      "Desactivalo si quieres explorar con camara libre.",
      "Combinalo con pausa para estudiar posiciones.",
    ],
    examples: [
      "Seguimiento puede ayudar en movimientos rapidos.",
      "Camara libre puede ser mejor para revisar una torre o columna concreta.",
    ],
    faqs: [
      faq("Seguimiento y camara libre son opuestos?", "Son formas distintas de controlar la vista; puedes alternarlas segun el analisis."),
      faq("Afecta el replay?", "No. Solo modifica como observas el tablero."),
    ],
    links: [
      link("Camara libre", "replay/camara-libre"),
      link("Ajustes", "ajustes"),
      link("Pausar replay", "replay/pausar-reproducir"),
    ],
    cta: { label: "Ver camara libre", path: "replay/camara-libre" },
    sources: ["F12", "F25", "F45"],
  },
  {
    slug: "replay/movil",
    category: "movil",
    title: "Replay en movil XIMA | Revisar partidas desde telefono",
    metaDescription:
      "Guia sobre replay en movil de XIMA: vista adaptada, controles, timeline y recomendaciones para pantalla pequena.",
    h1: "Replay en movil",
    intro:
      "El replay en movil usa una vista adaptada para reproducir partidas en pantallas mas pequenas.",
    verified:
      "La interfaz de replay contiene condiciones de viewport movil, layout movil y soporte de pantalla completa del iframe cuando aplica.",
    usage:
      "Usa el telefono en orientacion comoda, deja espacio para controles y apoya el analisis en pausa, velocidad y timeline.",
    caution:
      "Una pantalla pequena puede dificultar inspeccionar alturas; para analisis profundo, escritorio puede ser mas comodo.",
    examples: [
      "Puedes abrir una repeticion desde Ver partidos en movil si esta disponible.",
      "La timeline puede ocupar mas espacio vertical en telefono.",
    ],
    faqs: [
      faq("El replay movil tiene todas las funciones?", "La guia confirma adaptacion movil, pero la comodidad depende del dispositivo."),
      faq("Que hago si se ve pequeno?", "Prueba orientar el dispositivo o usar camara libre si esta disponible."),
    ],
    links: [
      link("Compatibilidad movil", "compatibilidad-movil"),
      link("Controles de replay", "replay/controles"),
      link("Camara libre", "replay/camara-libre"),
    ],
    cta: { label: "Ver controles", path: "replay/controles" },
    sources: ["F12", "F17"],
  },
  {
    slug: "solucion/no-hay-replay",
    category: "solucion",
    title: "No hay replay guardado en XIMA | Que revisar",
    metaDescription:
      "Aprende que hacer si una partida de XIMA no tiene replay guardado o el boton de repeticion aparece desactivado.",
    h1: "No hay replay guardado",
    intro:
      "Algunas partidas pueden no mostrar replay disponible, o el acceso puede estar desactivado en ciertas vistas.",
    verified:
      "La UI revisa si una partida tiene replay antes de permitir abrirlo, y muestra estados de replay no disponible.",
    usage:
      "Comprueba si la partida esta finalizada, si aparece en historial y si el boton de replay esta habilitado.",
    caution:
      "No prometas recuperar un replay que no fue registrado o que no esta disponible para el usuario.",
    steps: [
      "Abre Historial o la vista donde viste la partida.",
      "Busca si aparece el indicador o boton de replay.",
      "Comprueba que la partida este finalizada.",
      "Actualiza historial si acabas de terminarla.",
      "Contacta soporte si el problema se repite con partidas que deberian tener replay.",
    ],
    examples: [
      "En perfil de amigo puede aparecer Replay no disponible.",
      "En historial el boton puede estar deshabilitado si no hay registro.",
    ],
    faqs: [
      faq("Todas las partidas tienen replay?", "No se debe prometer. La disponibilidad depende del registro y del tipo de partida."),
      faq("Soporte puede necesitar mi cuenta?", "Describe el caso, pero no compartas contrasenas ni tokens."),
    ],
    links: [
      link("Ver replay", "tutoriales/ver-replay"),
      link("Actualizar historial", "tutoriales/actualizar-historial"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver replay", path: "tutoriales/ver-replay" },
    sources: ["F17", "F22", "F33"],
    structuredDataType: "HowTo",
  },
  {
    slug: "estadisticas/cimax-ciencia",
    category: "progreso",
    title: "CIMAX Ciencia en XIMA | Lectura publica del modo",
    metaDescription:
      "Conoce la lectura publica de CIMAX Ciencia en XIMA sin exponer formulas internas ni prometer reglas competitivas no confirmadas.",
    h1: "CIMAX Ciencia",
    intro:
      "CIMAX Ciencia es una puntuacion visible asociada al rendimiento del jugador en el modo Ciencia.",
    verified:
      "La pagina de estadisticas y ranking contiene etiquetas de CIMAX Ciencia y datos por modo.",
    usage:
      "Usalo como referencia de progreso en Ciencia y comparalo con historial, victorias y partidas registradas.",
    caution:
      "La formula exacta de CIMAX no se publica porque requiere aprobacion oficial.",
    confirmation:
      "La existencia visual esta verificada; la explicacion matematica queda pendiente.",
    examples: [
      "Un jugador puede revisar su CIMAX Ciencia junto a torneos ganados de Ciencia.",
      "El ranking Ciencia se relaciona con este tipo de progreso.",
    ],
    faqs: [
      faq("Esta pagina explica la formula?", "No. Solo explica la lectura publica visible."),
      faq("CIMAX Ciencia es igual a ranking global?", "No. Es una lectura por modo, mientras el global resume otra vista."),
    ],
    links: [
      link("CIMAX", "estadisticas/cimax"),
      link("Ranking Ciencia", "ranking/ciencia"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Ver CIMAX", path: "estadisticas/cimax" },
    sources: ["F19", "F20", "F47"],
    status: "partial",
  },
  {
    slug: "estadisticas/cimax-cienzar",
    category: "progreso",
    title: "CIMAX Cienzar en XIMA | Estado pendiente de confirmacion",
    metaDescription:
      "Pagina noindex sobre CIMAX Cienzar: dato visible en estadisticas, pero pendiente de definicion publica completa.",
    h1: "CIMAX Cienzar",
    intro:
      "CIMAX Cienzar aparece como dato por modo, pero su explicacion publica completa depende de la definicion oficial de Cienzar.",
    verified:
      "La interfaz de estadisticas contiene etiquetas de CIMAX Cienzar y torneos ganados Cienzar.",
    usage:
      "Por ahora debe leerse como una metrica visible del panel, no como formula explicada ni regla competitiva cerrada.",
    caution:
      "No se debe indexar hasta confirmar Cienzar y la politica publica de CIMAX por modo.",
    confirmation:
      "Pendiente confirmar definicion oficial de Cienzar y formula publica de CIMAX.",
    examples: [
      "Puede aparecer en tarjetas de estadisticas.",
      "Debe enlazarse con Cienzar noindex mientras la definicion este pendiente.",
    ],
    faqs: [
      faq("Por que no se indexa?", "Porque mezcla dos temas pendientes: Cienzar y formula CIMAX."),
      faq("La metrica existe visualmente?", "Si, aparece en la UI de estadisticas."),
    ],
    links: [
      link("Modo Cienzar", "cienzar"),
      link("Cienzar hibrido", "modos/cienzar-ciencia-y-azar"),
      link("CIMAX", "estadisticas/cimax"),
    ],
    cta: { label: "Ver CIMAX", path: "estadisticas/cimax" },
    sources: ["F19", "F20", "F47"],
    status: "ownerConfirmation",
  },
  {
    slug: "estadisticas/cimax-contrazar",
    category: "progreso",
    title: "CIMAX Contrazar en XIMA | Lectura con confirmaciones",
    metaDescription:
      "Guia prudente sobre CIMAX Contrazar en XIMA: donde aparece, como leerlo y que queda por confirmar oficialmente.",
    h1: "CIMAX Contrazar",
    intro:
      "CIMAX Contrazar es una lectura visible en estadisticas relacionada con el modo o categoria Contrazar.",
    verified:
      "La interfaz de estadisticas contiene etiquetas de CIMAX Contrazar y torneos ganados Contrazar.",
    usage:
      "Lee este dato como una separacion de rendimiento por categoria mientras se confirma el significado publico exacto de Contrazar.",
    caution:
      "La guia no publica formulas ni define Contrazar como modo independiente cerrado.",
    confirmation:
      "Pendiente confirmar si Contrazar debe explicarse como alias, categoria o submodo.",
    examples: [
      "Puede compararse con CIMAX Ciencia y CIMAX Azar dentro del panel.",
      "Ranking Contrazar debe usar la misma prudencia terminologica.",
    ],
    faqs: [
      faq("Contrazar esta confirmado como modo?", "El nombre aparece en datos, pero su definicion publica requiere confirmacion."),
      faq("Se publica formula?", "No. La formula CIMAX no se expone."),
    ],
    links: [
      link("Contrazar", "modos/contrazar"),
      link("Ranking Contrazar", "ranking/contrazar"),
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
    ],
    cta: { label: "Ver Ciencia V/S Azar", path: "modos/ciencia-vs-azar" },
    sources: ["F19", "F20", "F47"],
    status: "partial",
  },
  {
    slug: "estadisticas/cimax-azar",
    category: "progreso",
    title: "CIMAX Azar en XIMA | Progreso en modos con dados",
    metaDescription:
      "Aprende como leer CIMAX Azar en XIMA como metrica visible de progreso por modo sin revelar formulas internas.",
    h1: "CIMAX Azar",
    intro:
      "CIMAX Azar es una puntuacion visible asociada a rendimiento en el entorno de juego con dados.",
    verified:
      "Estadisticas muestra CIMAX Azar y datos por modo, y Ranking separa secciones por modo.",
    usage:
      "Usalo para seguir progreso en partidas de Azar junto a historial, victorias y torneos ganados por modo.",
    caution:
      "No se publica la formula ni se afirma como indicador absoluto de habilidad.",
    confirmation:
      "La lectura publica esta verificada; la formula exacta sigue pendiente de aprobacion.",
    examples: [
      "Un jugador que practica Azar puede revisar su CIMAX Azar despues de partidas registradas.",
      "Ranking Azar ayuda a comparar posicion en la categoria correspondiente.",
    ],
    faqs: [
      faq("CIMAX Azar depende solo de suerte?", "La guia no afirma eso. Solo explica la metrica visible por modo."),
      faq("Donde aprendo el modo?", "Consulta Modo Azar y Dados en XIMA."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Ranking Azar", "ranking/azar"),
      link("Dados en XIMA", "reglas/dados"),
    ],
    cta: { label: "Ver Ranking Azar", path: "ranking/azar" },
    sources: ["F19", "F20", "F47"],
    status: "partial",
  },
  {
    slug: "estadisticas/torneos-ganados-por-modo",
    category: "progreso",
    title: "Torneos ganados por modo en XIMA | Estadistica visible",
    metaDescription:
      "Conoce la estadistica de torneos ganados por modo en XIMA y su relacion con Ciencia, Cienzar, Contrazar y Azar.",
    h1: "Torneos ganados por modo",
    intro:
      "Torneos ganados por modo separa victorias competitivas segun la categoria de juego registrada.",
    verified:
      "La pantalla de estadisticas contiene etiquetas de torneos ganados para Ciencia, Cienzar, Contrazar y Azar.",
    usage:
      "Sirve para revisar en que modos tienes resultados registrados y para conectar progreso con ranking.",
    caution:
      "La definicion oficial de torneo y reglas de premios requiere confirmacion en paginas comerciales o competitivas.",
    examples: [
      "Puedes tener torneos ganados en Ciencia y otros datos en Azar.",
      "La vista por modo evita mezclar resultados de reglas distintas.",
    ],
    faqs: [
      faq("Incluye partidas normales?", "La guia solo confirma la metrica visible de torneos ganados, no reclasifica partidas."),
      faq("Cienzar y Contrazar estan explicados?", "Aparecen como categorias visibles, pero su definicion fina sigue pendiente."),
    ],
    links: [
      link("Estadisticas", "estadisticas"),
      link("Torneos", "torneos"),
      link("Ranking por modo", "ranking/por-modo"),
    ],
    cta: { label: "Ver estadisticas", path: "estadisticas" },
    sources: ["F19", "F20", "F32"],
  },
  {
    slug: "estadisticas/tiempo-jugado",
    category: "progreso",
    title: "Tiempo total jugado en XIMA | Metrica de actividad",
    metaDescription:
      "Aprende que significa tiempo total jugado en XIMA y como se relaciona con historial, perfil y partidas registradas.",
    h1: "Tiempo total jugado",
    intro:
      "Tiempo total jugado resume actividad registrada en partidas de XIMA.",
    verified:
      "La documentacion de estadisticas menciona tiempo total jugado y datos derivados del historial de partidas.",
    usage:
      "Usalo como indicador de actividad, no como prueba unica de nivel, habilidad o ranking.",
    caution:
      "La medicion depende de partidas registradas y de como el sistema guarde cada sesion.",
    examples: [
      "Un jugador puede tener mucho tiempo jugado y aun asi revisar win rate por separado.",
      "El historial ayuda a entender de donde vienen los datos.",
    ],
    faqs: [
      faq("Tiempo jugado es lo mismo que victorias?", "No. Tiempo mide actividad; victorias mide resultados."),
      faq("Incluye todas las partidas?", "Depende de los registros disponibles en el sistema."),
    ],
    links: [
      link("Historial de partidas", "historial"),
      link("Win rate", "estadisticas/win-rate"),
      link("Perfil", "perfil"),
    ],
    cta: { label: "Ver historial", path: "historial" },
    sources: ["F19", "F22", "F33"],
  },
  {
    slug: "estadisticas/win-rate",
    category: "progreso",
    title: "Win rate en XIMA | Como leer victorias y derrotas",
    metaDescription:
      "Guia sobre win rate en XIMA: relacion entre victorias, derrotas, historial, ranking y limites de interpretacion.",
    h1: "Win rate",
    intro:
      "Win rate es una forma de leer la proporcion de victorias frente a partidas registradas.",
    verified:
      "Estadisticas e historial muestran partidas, victorias y derrotas, lo que permite presentar una lectura de rendimiento.",
    usage:
      "Analizalo junto con modo, rivales, tiempo jugado y racha para evitar conclusiones simplistas.",
    caution:
      "No se debe usar como unico criterio competitivo oficial si el proyecto no lo define asi.",
    examples: [
      "Un win rate alto en pocas partidas no significa lo mismo que una muestra grande.",
      "Comparar win rate por modo puede ser mas util que mezclar todos los modos.",
    ],
    faqs: [
      faq("Win rate aparece como formula oficial?", "La guia lo trata como lectura de victorias/partidas, no como formula competitiva oficial."),
      faq("Sirve para ranking?", "Ranking usa sus propias puntuaciones visibles; no se debe asumir equivalencia directa."),
    ],
    links: [
      link("Estadisticas", "estadisticas"),
      link("Ranking", "ranking"),
      link("Historial", "historial"),
    ],
    cta: { label: "Ver estadisticas", path: "estadisticas" },
    sources: ["F19", "F22", "F33"],
  },
  {
    slug: "estadisticas/racha-victorias",
    category: "progreso",
    title: "Racha de victorias en XIMA | Progreso y lectura",
    metaDescription:
      "Aprende que significa racha de victorias en XIMA, como se relaciona con estadisticas y por que depende de partidas registradas.",
    h1: "Racha de victorias",
    intro:
      "La racha de victorias resume una secuencia de resultados positivos registrados.",
    verified:
      "La documentacion de estadisticas incluye racha de victorias, mejor racha y datos relacionados con partidas.",
    usage:
      "Usala para seguir consistencia reciente, pero revisa modo y rivales antes de compararla con otros datos.",
    caution:
      "No se publica una regla competitiva externa para premios o ranking basada solo en racha.",
    examples: [
      "Una racha puede mejorar en un modo y no en otro.",
      "El historial ayuda a comprobar la secuencia de resultados.",
    ],
    faqs: [
      faq("Racha actual y mejor racha son iguales?", "No. Una describe el momento actual y otra el maximo registrado."),
      faq("La racha garantiza ranking?", "No. Ranking se muestra como sistema separado."),
    ],
    links: [
      link("Historial", "historial"),
      link("Win rate", "estadisticas/win-rate"),
      link("Ranking global", "ranking/global"),
    ],
    cta: { label: "Ver historial", path: "historial" },
    sources: ["F19", "F22", "F33"],
  },
  {
    slug: "estadisticas/bloques-capturados",
    category: "progreso",
    title: "Bloques capturados en XIMA | Estadistica de partida",
    metaDescription:
      "Conoce la metrica de bloques capturados en XIMA y su relacion con reglas de captura, historial y perfil.",
    h1: "Bloques capturados",
    intro:
      "Bloques capturados es una estadistica de rendimiento relacionada con la interaccion de bloques en el tablero.",
    verified:
      "La documentacion de estadisticas lista bloques capturados y especiales capturadas cuando los datos estan disponibles.",
    usage:
      "Lee esta metrica junto con reglas de dominacion, captura, modo y resultado final de la partida.",
    caution:
      "No se explica aqui la formula interna de captura ni casos tecnicos de tablero no publicados.",
    examples: [
      "Capturar bloques puede influir en control de columnas.",
      "Capturar especial se relaciona con reglas de rescate.",
    ],
    faqs: [
      faq("Captura y victoria son lo mismo?", "No. La victoria central se relaciona con el especial en la cima, aunque las capturas influyen."),
      faq("Se ven en perfil?", "La documentacion interna conecta estas metricas con perfil y estadisticas cuando estan disponibles."),
    ],
    links: [
      link("Bloques comunes y especiales", "reglas/bloques"),
      link("Rescate de bloques", "reglas/rescate"),
      link("Perfil", "perfil"),
    ],
    cta: { label: "Ver bloques", path: "reglas/bloques" },
    sources: ["F19", "F22", "F33"],
  },
  {
    slug: "ranking/global",
    category: "ranking",
    title: "Ranking global de XIMA | Tabla general de jugadores",
    metaDescription:
      "Aprende que muestra el ranking global de XIMA, como leer puntuacion total y como se diferencia de ranking por modo.",
    h1: "Ranking global",
    intro:
      "El ranking global resume una vista general de jugadores ordenados por puntuacion visible.",
    verified:
      "La pagina Ranking construye una seccion global a partir de datos por modo y muestra nombres, iniciales y puntuaciones.",
    usage:
      "Usalo para una comparacion general, y entra a rankings por modo si quieres revisar rendimiento especifico.",
    caution:
      "No se publica formula interna ni criterios privados de calculo.",
    examples: [
      "Un jugador puede aparecer en global por acumulacion de datos visibles.",
      "Los rankings por modo ayudan a entender mejor su especialidad.",
    ],
    faqs: [
      faq("Global es lo mismo que Ciencia?", "No. Ciencia es una seccion por modo."),
      faq("Muestra jugadores online?", "La documentacion de ranking menciona estado online en contexto global."),
    ],
    links: [
      link("Ranking por modo", "ranking/por-modo"),
      link("Presencia en ranking", "ranking/jugadores-en-linea"),
      link("CIMAX", "estadisticas/cimax"),
    ],
    cta: { label: "Ver ranking por modo", path: "ranking/por-modo" },
    sources: ["F20", "F32"],
  },
  {
    slug: "ranking/por-modo",
    category: "ranking",
    title: "Ranking por modo en XIMA | Ciencia, Azar y categorias",
    metaDescription:
      "Guia del ranking por modo en XIMA: Ciencia, Cienzar, Contrazar, Azar y lectura prudente de puntuaciones.",
    h1: "Ranking por modo",
    intro:
      "El ranking por modo separa jugadores segun la categoria de juego registrada.",
    verified:
      "Ranking incluye secciones para Ciencia, Cienzar, Contrazar, Azar y Global.",
    usage:
      "Consulta el modo que te interesa para comparar rendimiento con reglas y contextos similares.",
    caution:
      "Cienzar y Contrazar requieren confirmaciones de definicion publica antes de guias completas.",
    examples: [
      "Ranking Ciencia es mejor para comparar partidas sin dados.",
      "Ranking Azar separa resultados asociados a dados.",
    ],
    faqs: [
      faq("Por que separar por modo?", "Porque cada modo puede tener condiciones distintas."),
      faq("Todos los modos estan listos para explicacion completa?", "No. Algunos tienen paginas marcadas como pendientes."),
    ],
    links: [
      link("Ranking Ciencia", "ranking/ciencia"),
      link("Ranking Azar", "ranking/azar"),
      link("Ranking global", "ranking/global"),
    ],
    cta: { label: "Ver Ranking Ciencia", path: "ranking/ciencia" },
    sources: ["F20", "F32"],
  },
  {
    slug: "ranking/ciencia",
    category: "ranking",
    title: "Ranking Ciencia en XIMA | Comparar rendimiento estrategico",
    metaDescription:
      "Conoce Ranking Ciencia en XIMA y como se relaciona con Modo Ciencia, CIMAX Ciencia y progreso sin dados.",
    h1: "Ranking Ciencia",
    intro:
      "Ranking Ciencia muestra jugadores dentro de la categoria asociada al modo Ciencia.",
    verified:
      "Ranking contiene modo Ciencia y estadisticas muestra CIMAX Ciencia como puntuacion por modo.",
    usage:
      "Usalo para comparar rendimiento en un entorno donde la decision directa de movimiento es central.",
    caution:
      "No se publica formula de puntuacion ni criterios internos de desempate.",
    examples: [
      "Un jugador que practica Ciencia puede revisar su posicion en Ranking Ciencia.",
      "CIMAX Ciencia ayuda a enlazar ranking y estadisticas.",
    ],
    faqs: [
      faq("Ranking Ciencia usa dados?", "La guia lo asocia a Modo Ciencia, que se documenta separado de Azar."),
      faq("Es igual que Ranking global?", "No. Es una vista por modo."),
    ],
    links: [
      link("Modo Ciencia", "ciencia"),
      link("CIMAX Ciencia", "estadisticas/cimax-ciencia"),
      link("Ranking por modo", "ranking/por-modo"),
    ],
    cta: { label: "Ver Modo Ciencia", path: "ciencia" },
    sources: ["F20", "F32"],
  },
  {
    slug: "ranking/cienzar",
    category: "ranking",
    title: "Ranking Cienzar en XIMA | Estado noindex pendiente",
    metaDescription:
      "Pagina prudente sobre Ranking Cienzar en XIMA, marcada noindex hasta confirmar definicion publica del modo.",
    h1: "Ranking Cienzar",
    intro:
      "Ranking Cienzar aparece como categoria visible, pero la explicacion completa depende de confirmar Cienzar.",
    verified:
      "Ranking y estadisticas contienen referencias a Cienzar como categoria por modo.",
    usage:
      "Se puede reconocer como vista visible, pero no debe explicarse con reglas no confirmadas.",
    caution:
      "Mantener noindex hasta tener definicion oficial de Cienzar y criterio publico de ranking.",
    confirmation:
      "Pendiente confirmar reglas publicas, formula de CIMAX y etiqueta oficial.",
    examples: [
      "Puede aparecer junto a Ciencia, Contrazar y Azar.",
      "Debe enlazar con Cienzar, tambien marcado con confirmacion pendiente.",
    ],
    faqs: [
      faq("Por que esta pagina no se indexa?", "Porque depende de una definicion de modo pendiente."),
      faq("Existe la categoria en UI?", "Si, aparece en fuentes de ranking y estadisticas."),
    ],
    links: [
      link("Modo Cienzar", "cienzar"),
      link("CIMAX Cienzar", "estadisticas/cimax-cienzar"),
      link("Ranking por modo", "ranking/por-modo"),
    ],
    cta: { label: "Ver ranking por modo", path: "ranking/por-modo" },
    sources: ["F20", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "ranking/contrazar",
    category: "ranking",
    title: "Ranking Contrazar en XIMA | Categoria visible y cautelas",
    metaDescription:
      "Guia sobre Ranking Contrazar en XIMA: categoria visible, relacion con CIMAX Contrazar y puntos pendientes.",
    h1: "Ranking Contrazar",
    intro:
      "Ranking Contrazar es una categoria visible en el sistema de ranking por modo.",
    verified:
      "Ranking y estadisticas contienen referencias a Contrazar, incluyendo etiquetas de CIMAX y torneos ganados.",
    usage:
      "Usalo como lectura de categoria visible hasta que el propietario confirme la definicion final de Contrazar.",
    caution:
      "No se presenta como modo independiente con reglas propias hasta tener confirmacion.",
    confirmation:
      "Falta confirmar terminologia publica de Contrazar y su relacion exacta con Ciencia V/S Azar.",
    examples: [
      "Puede servir para comparar resultados en una categoria diferenciada.",
      "Conviene revisar tambien Ciencia V/S Azar para contexto.",
    ],
    faqs: [
      faq("Contrazar es oficial?", "El nombre esta en fuentes, pero su explicacion publica sigue parcial."),
      faq("Debe tener formula propia?", "No se publica ninguna formula."),
    ],
    links: [
      link("Contrazar", "modos/contrazar"),
      link("CIMAX Contrazar", "estadisticas/cimax-contrazar"),
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
    ],
    cta: { label: "Ver CIMAX Contrazar", path: "estadisticas/cimax-contrazar" },
    sources: ["F20", "F32"],
    status: "partial",
  },
  {
    slug: "ranking/azar",
    category: "ranking",
    title: "Ranking Azar en XIMA | Competir en modo con dados",
    metaDescription:
      "Aprende que muestra Ranking Azar en XIMA y como se relaciona con Modo Azar, dados y CIMAX Azar.",
    h1: "Ranking Azar",
    intro:
      "Ranking Azar separa el progreso de jugadores en la categoria asociada a modos con dados.",
    verified:
      "Ranking contiene seccion Azar y estadisticas muestra CIMAX Azar como metrica por modo.",
    usage:
      "Consultalo si juegas Azar y quieres comparar rendimiento en una categoria separada de Ciencia.",
    caution:
      "No se explica formula de puntuacion ni detalles internos del leaderboard.",
    examples: [
      "Un jugador de dados puede revisar Ranking Azar y luego analizar sus partidas en historial.",
      "CIMAX Azar ayuda a leer progreso personal en esa categoria.",
    ],
    faqs: [
      faq("Ranking Azar depende solo del dado?", "La guia no afirma eso; el juego mantiene reglas de tablero y movimientos."),
      faq("Como aprendo el modo?", "Lee Modo Azar y Dados en XIMA."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("CIMAX Azar", "estadisticas/cimax-azar"),
      link("Dados en XIMA", "reglas/dados"),
    ],
    cta: { label: "Ver Modo Azar", path: "azar" },
    sources: ["F20", "F32"],
  },
  {
    slug: "ranking/jugadores-en-linea",
    category: "ranking",
    title: "Jugadores en linea en Ranking XIMA | Presencia visible",
    metaDescription:
      "Conoce como se interpreta la presencia en linea dentro del ranking global de XIMA sin exponer datos privados.",
    h1: "Presencia en ranking",
    intro:
      "La presencia en ranking ayuda a identificar actividad visible de jugadores dentro de algunas vistas.",
    verified:
      "La documentacion de ranking menciona estado online en contexto global y la UI maneja datos de jugadores visibles.",
    usage:
      "Usalo como senal de actividad, no como garantia de disponibilidad para jugar o aceptar invitaciones.",
    caution:
      "La politica exacta de visibilidad online requiere confirmacion para explicaciones publicas detalladas.",
    confirmation:
      "Pendiente confirmar que estados se muestran publicamente y con que alcance.",
    examples: [
      "Un jugador puede aparecer activo en contexto de ranking.",
      "Para invitar, conviene revisar Amigos y el estado de partida.",
    ],
    faqs: [
      faq("Presencia en linea revela datos privados?", "Esta guia no expone datos privados; solo explica el indicador visible."),
      faq("Significa que puedo retar a ese jugador?", "No necesariamente. Depende del estado social y de partida."),
    ],
    links: [
      link("Ranking global", "ranking/global"),
      link("Estado de jugador", "perfil/estado-jugador"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Ver Amigos", path: "amigos" },
    sources: ["F20", "F32"],
    status: "partial",
  },
  {
    slug: "perfil/codigo-de-jugador",
    category: "perfil",
    title: "Codigo de jugador XIMA | Buscar y agregar amigos",
    metaDescription:
      "Aprende que es el codigo de jugador en XIMA, como se usa para buscar amigos y que datos no debes compartir.",
    h1: "Codigo de jugador",
    intro:
      "El codigo de jugador identifica publicamente a una cuenta dentro de flujos sociales como buscar y agregar amigos.",
    verified:
      "Amigos permite ver el codigo propio, copiarlo y buscar otros jugadores por codigo con formato publico tipo XIMA-####.",
    usage:
      "Comparte tu codigo de jugador cuando quieras que alguien te encuentre, sin compartir correo, contrasena ni informacion privada.",
    caution:
      "El codigo de jugador no debe mezclarse con credenciales de acceso ni datos personales.",
    examples: [
      "Un amigo puede usar tu codigo para enviarte solicitud.",
      "En solicitudes recibidas aparece el codigo del jugador relacionado.",
    ],
    faqs: [
      faq("El codigo de jugador es secreto?", "No es una contrasena, pero compartelo solo donde tenga sentido social."),
      faq("Sirve para iniciar sesion?", "No. Es para busqueda e identificacion social dentro del juego."),
    ],
    links: [
      link("Buscar jugador", "tutoriales/buscar-jugador"),
      link("Enviar solicitud", "tutoriales/enviar-solicitud-amistad"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Buscar jugador", path: "tutoriales/buscar-jugador" },
    sources: ["F21", "F22", "F34"],
  },
  {
    slug: "perfil/avatar",
    category: "perfil",
    title: "Avatar de perfil XIMA | Personalizacion visible",
    metaDescription:
      "Conoce el avatar de perfil en XIMA, su relacion con perfil, personalizacion y skins sin exponer datos privados.",
    h1: "Avatar de perfil",
    intro:
      "El avatar de perfil representa visualmente al jugador en secciones sociales y de cuenta.",
    verified:
      "El proyecto contiene pantalla de personalizacion con avatares y datos de perfil asociados a la cuenta.",
    usage:
      "Usa el avatar para reconocer perfiles en amigos, ranking u otras vistas donde aparezca informacion publica del jugador.",
    caution:
      "No uses imagenes o nombres que expongan informacion personal sensible.",
    examples: [
      "Un perfil puede mostrar iniciales o imagen de avatar.",
      "La personalizacion puede convivir con skins de bloques.",
    ],
    faqs: [
      faq("Avatar y skin son lo mismo?", "No. Avatar identifica el perfil; skin personaliza bloques o elementos visuales."),
      faq("Aparece en ranking?", "La UI puede mostrar avatar o iniciales segun datos disponibles."),
    ],
    links: [
      link("Editar perfil", "tutoriales/editar-perfil"),
      link("Skins", "tienda/skins"),
      link("Perfil", "perfil"),
    ],
    cta: { label: "Editar perfil", path: "tutoriales/editar-perfil" },
    sources: ["F24", "F31"],
  },
  {
    slug: "tutoriales/editar-perfil",
    category: "tutorial",
    title: "Editar perfil en XIMA | Avatar y datos visibles",
    metaDescription:
      "Guia para editar el perfil en XIMA desde la personalizacion visible, cuidando avatar, nombre y privacidad.",
    h1: "Editar perfil",
    intro:
      "Editar perfil permite ajustar elementos visibles de la cuenta, como avatar o personalizacion disponible.",
    verified:
      "El proyecto incluye DesignMode, datos de usuario y seleccion de avatar o skins asociados al perfil.",
    usage:
      "Cambia solo informacion que quieras mostrar publicamente o dentro de funciones sociales.",
    caution:
      "No publiques datos personales, correos, claves ni informacion sensible en campos visibles.",
    steps: [
      "Abre Perfil o personalizacion.",
      "Revisa las opciones visibles de avatar y estilos.",
      "Selecciona el elemento que quieres usar.",
      "Guarda si el flujo lo solicita.",
      "Vuelve al lobby o revisa el perfil para confirmar.",
    ],
    examples: [
      "Puedes elegir un avatar visual para que otros te reconozcan.",
      "Los skins de bloques se gestionan en secciones relacionadas con tienda o personalizacion.",
    ],
    faqs: [
      faq("Editar perfil cambia mis estadisticas?", "No. Son areas distintas."),
      faq("Puedo usar cualquier imagen?", "La guia solo confirma avatares del proyecto; no afirma carga libre de imagenes."),
    ],
    links: [
      link("Avatar de perfil", "perfil/avatar"),
      link("Skins", "tienda/skins"),
      link("Perfil", "perfil"),
    ],
    cta: { label: "Ver avatar", path: "perfil/avatar" },
    sources: ["F24", "F31"],
  },
  {
    slug: "perfil/estado-jugador",
    category: "perfil",
    title: "Estado de jugador en XIMA | Amigos y partidas",
    metaDescription:
      "Aprende como leer el estado de jugador en XIMA dentro de amigos, perfiles y partidas sin invadir privacidad.",
    h1: "Estado de jugador",
    intro:
      "El estado de jugador ayuda a saber si una persona puede estar disponible, en partida o relacionada con una invitacion.",
    verified:
      "Amigos y perfiles manejan estados, partida activa, espectabilidad e invitaciones segun datos visibles.",
    usage:
      "Antes de invitar o unirte a un amigo, revisa el estado visible y las acciones habilitadas.",
    caution:
      "La politica publica de visibilidad de estado online queda pendiente de confirmacion.",
    confirmation:
      "Falta confirmar el alcance exacto de estado online, en partida y espectable para documentarlo con capturas.",
    examples: [
      "Un amigo puede aparecer con estado en partida si hay una partida activa.",
      "La accion de unirse depende de que el estado lo permita.",
    ],
    faqs: [
      faq("Estado de jugador siempre es exacto?", "Depende de la actualizacion del sistema y datos disponibles."),
      faq("Puedo ocultar mi estado?", "La guia no confirma opciones de privacidad; requiere revision del propietario."),
    ],
    links: [
      link("Perfil de amigo", "perfil/amigo"),
      link("Unirse a partida de un amigo", "tutoriales/unirse-partida-amigo"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Ver perfil de amigo", path: "perfil/amigo" },
    sources: ["F21", "F22", "F34"],
    status: "partial",
  },
  {
    slug: "perfil/amigo",
    category: "perfil",
    title: "Perfil de amigo en XIMA | Historial, replay y acciones",
    metaDescription:
      "Conoce que puedes ver en el perfil de un amigo en XIMA: datos publicos, partidas, replay disponible y acciones sociales.",
    h1: "Perfil de amigo",
    intro:
      "El perfil de amigo muestra informacion visible de otro jugador y puede enlazar con partidas o replay cuando esta disponible.",
    verified:
      "FriendProfile permite volver a Amigos, abrir replay si existe y mostrar datos publicos del jugador relacionado.",
    usage:
      "Usalo para revisar actividad visible, reconocer al jugador y abrir repeticiones disponibles sin exponer datos privados.",
    caution:
      "No se deben publicar datos reales de usuarios en ejemplos publicos sin consentimiento.",
    examples: [
      "Puede aparecer el boton Reproducir si una partida tiene replay.",
      "El perfil ayuda a ubicar a un jugador desde una solicitud o lista de amigos.",
    ],
    faqs: [
      faq("Veo todo el historial de un amigo?", "La guia solo confirma datos visibles del perfil, no acceso total a datos privados."),
      faq("Puedo abrir replay desde ahi?", "Si el match tiene replay disponible, la UI puede permitir Reproducir."),
    ],
    links: [
      link("Amigos", "amigos"),
      link("Ver replay", "tutoriales/ver-replay"),
      link("Estado de jugador", "perfil/estado-jugador"),
    ],
    cta: { label: "Ver Amigos", path: "amigos" },
    sources: ["F22", "F34"],
  },
  {
    slug: "tutoriales/buscar-jugador",
    category: "tutorial",
    title: "Buscar jugador en XIMA | Usar codigo de jugador",
    metaDescription:
      "Aprende como buscar un jugador en XIMA usando su codigo publico y como continuar con una solicitud de amistad.",
    h1: "Buscar jugador",
    intro:
      "Buscar jugador permite encontrar cuentas por codigo para iniciar una relacion social dentro de XIMA.",
    verified:
      "La seccion Amigos contiene busqueda por codigo, placeholder Buscar jugador... y acciones para enviar solicitud.",
    usage:
      "Pide el codigo de jugador a la persona correcta y verifica el perfil antes de enviar la solicitud.",
    caution:
      "No uses correos, contrasenas ni identificadores privados como ejemplo publico.",
    steps: [
      "Abre Amigos.",
      "Localiza el campo Buscar jugador...",
      "Escribe el codigo del jugador.",
      "Revisa el resultado visible.",
      "Envia solicitud si corresponde.",
    ],
    examples: [
      "Un codigo publico tipo XIMA-#### puede usarse para buscar.",
      "Si no aparece resultado, revisa que el codigo este completo.",
    ],
    faqs: [
      faq("Puedo buscar por email?", "La guia publica recomienda usar codigo de jugador, no datos privados."),
      faq("Buscar envia solicitud automaticamente?", "No. Despues de encontrar el jugador debes usar la accion de solicitud si esta disponible."),
    ],
    links: [
      link("Codigo de jugador", "perfil/codigo-de-jugador"),
      link("Enviar solicitud de amistad", "tutoriales/enviar-solicitud-amistad"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Enviar solicitud", path: "tutoriales/enviar-solicitud-amistad" },
    sources: ["F21", "F34"],
  },
  {
    slug: "tutoriales/aceptar-solicitud-amistad",
    category: "tutorial",
    title: "Aceptar solicitud de amistad en XIMA | Guia social",
    metaDescription:
      "Aprende como aceptar una solicitud de amistad en XIMA desde la seccion Amigos y que revisar antes de confirmar.",
    h1: "Aceptar solicitud de amistad",
    intro:
      "Aceptar una solicitud agrega a otro jugador a tu red social dentro de XIMA.",
    verified:
      "La seccion Amigos muestra solicitudes recibidas y una accion con aria-label Aceptar solicitud.",
    usage:
      "Revisa el nombre, codigo y contexto antes de aceptar. Despues podras ver al jugador en tu lista de amigos.",
    caution:
      "No aceptes solicitudes si no reconoces al jugador o si sospechas abuso.",
    steps: [
      "Abre Amigos.",
      "Busca la seccion Recibidas.",
      "Revisa nombre y codigo del jugador.",
      "Pulsa Aceptar solicitud.",
      "Comprueba que el jugador aparezca en tu lista.",
    ],
    examples: [
      "Una solicitud recibida puede mostrar codigo y fecha relativa.",
      "Aceptar habilita interacciones sociales como invitaciones segun estado.",
    ],
    faqs: [
      faq("Aceptar comparte mi contrasena?", "No. Nunca debes compartir contrasenas para agregar amigos."),
      faq("Puedo rechazar en vez de aceptar?", "Si. La interfaz tambien tiene Rechazar solicitud."),
    ],
    links: [
      link("Rechazar solicitud", "tutoriales/rechazar-solicitud-amistad"),
      link("Amigos", "amigos"),
      link("Invitar amigo a partida", "tutoriales/invitar-amigo-a-partida"),
    ],
    cta: { label: "Invitar amigo", path: "tutoriales/invitar-amigo-a-partida" },
    sources: ["F21", "F34"],
  },
  {
    slug: "tutoriales/rechazar-solicitud-amistad",
    category: "tutorial",
    title: "Rechazar solicitud de amistad en XIMA | Control social",
    metaDescription:
      "Guia para rechazar una solicitud de amistad en XIMA y mantener control sobre tu lista de contactos.",
    h1: "Rechazar solicitud de amistad",
    intro:
      "Rechazar una solicitud permite no agregar a un jugador a tu lista de amigos.",
    verified:
      "La seccion Amigos incluye una accion con aria-label Rechazar solicitud para solicitudes recibidas.",
    usage:
      "Usala cuando no reconoces al jugador, no quieres agregarlo o prefieres mantener tu lista limitada.",
    caution:
      "Esta guia no explica mecanismos internos de bloqueo o moderacion si no estan en el flujo publico revisado.",
    steps: [
      "Abre Amigos.",
      "Ve a solicitudes Recibidas.",
      "Revisa quien envio la solicitud.",
      "Pulsa Rechazar solicitud.",
      "Comprueba que desaparezca de pendientes si la accion se completa.",
    ],
    examples: [
      "Puedes rechazar solicitudes de jugadores desconocidos.",
      "Si fue un error, el otro jugador tendria que enviar otra solicitud segun el flujo disponible.",
    ],
    faqs: [
      faq("Rechazar notifica al otro jugador?", "La guia no confirma detalles de notificacion."),
      faq("Es lo mismo que cancelar?", "No. Rechazar aplica a recibidas; cancelar aplica a solicitudes enviadas por ti."),
    ],
    links: [
      link("Cancelar solicitud", "tutoriales/cancelar-solicitud-amistad"),
      link("Aceptar solicitud", "tutoriales/aceptar-solicitud-amistad"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Ver Amigos", path: "amigos" },
    sources: ["F21", "F34"],
  },
  {
    slug: "tutoriales/cancelar-solicitud-amistad",
    category: "tutorial",
    title: "Cancelar solicitud de amistad en XIMA | Solicitudes enviadas",
    metaDescription:
      "Aprende a cancelar una solicitud de amistad enviada en XIMA desde Amigos y como se diferencia de rechazar.",
    h1: "Cancelar solicitud de amistad",
    intro:
      "Cancelar una solicitud retira una invitacion de amistad que enviaste y que sigue pendiente.",
    verified:
      "Amigos muestra solicitudes Enviadas y un boton Cancelar para solicitudes pendientes.",
    usage:
      "Usalo si enviaste una solicitud por error o ya no quieres esperar respuesta.",
    caution:
      "No se documentan reglas internas de reintentos o limites de solicitudes.",
    steps: [
      "Abre Amigos.",
      "Busca la seccion Enviadas.",
      "Localiza la solicitud pendiente.",
      "Pulsa Cancelar.",
      "Verifica que deje de aparecer como pendiente.",
    ],
    examples: [
      "Una solicitud enviada puede mostrar estado Pendiente.",
      "Cancelar no equivale a rechazar una solicitud recibida.",
    ],
    faqs: [
      faq("Puedo volver a enviar solicitud?", "La guia no confirma limites; revisa la interfaz despues de cancelar."),
      faq("Cancelar elimina un amigo existente?", "No. Aplica a solicitudes pendientes enviadas."),
    ],
    links: [
      link("Buscar jugador", "tutoriales/buscar-jugador"),
      link("Enviar solicitud de amistad", "tutoriales/enviar-solicitud-amistad"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Buscar jugador", path: "tutoriales/buscar-jugador" },
    sources: ["F21", "F34"],
  },
  {
    slug: "tutoriales/aceptar-invitacion-partida",
    category: "tutorial",
    title: "Aceptar invitacion a partida en XIMA | Jugar con amigos",
    metaDescription:
      "Aprende como aceptar una invitacion a partida en XIMA desde Amigos cuando el estado de la partida lo permite.",
    h1: "Aceptar invitacion a partida",
    intro:
      "Aceptar una invitacion a partida te permite entrar a un juego propuesto por un amigo o contacto compatible.",
    verified:
      "Amigos maneja invitaciones de partida y acciones para aceptar, rechazar o cancelar segun el estado.",
    usage:
      "Antes de aceptar, revisa quien invita, el modo si esta visible y si estas listo para jugar.",
    caution:
      "La invitacion puede expirar, cambiar de estado o no estar disponible si la partida se llena.",
    steps: [
      "Abre Amigos.",
      "Revisa invitaciones pendientes.",
      "Identifica quien envio la invitacion.",
      "Pulsa Aceptar si quieres entrar.",
      "Espera la navegacion o estado de partida correspondiente.",
    ],
    examples: [
      "Una invitacion puede venir de un amigo agregado.",
      "Si la partida ya no existe, la accion puede dejar de estar disponible.",
    ],
    faqs: [
      faq("Aceptar invitacion crea una partida nueva?", "No. Te une al flujo relacionado con la invitacion existente."),
      faq("Puedo rechazarla?", "Si la UI lo permite, puedes rechazar una invitacion pendiente."),
    ],
    links: [
      link("Invitar amigo a partida", "tutoriales/invitar-amigo-a-partida"),
      link("Unirse partida amigo", "tutoriales/unirse-partida-amigo"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Unirse a partida de amigo", path: "tutoriales/unirse-partida-amigo" },
    sources: ["F21", "F34", "F32"],
  },
  {
    slug: "tutoriales/unirse-partida-amigo",
    category: "tutorial",
    title: "Unirse a partida de un amigo en XIMA | Estado y acceso",
    metaDescription:
      "Guia para unirse a una partida de un amigo en XIMA cuando la partida esta disponible o es espectable.",
    h1: "Unirse a partida de un amigo",
    intro:
      "Unirse a la partida de un amigo depende del estado visible del jugador y de la disponibilidad de la partida.",
    verified:
      "Amigos evalua estados como en partida, partida activa y espectabilidad para habilitar acciones relacionadas.",
    usage:
      "Revisa si el amigo esta en partida y si aparece una accion para unirte, mirar o abrir el flujo correspondiente.",
    caution:
      "No todas las partidas de amigos seran accesibles; puede haber privacidad, capacidad o estado cerrado.",
    steps: [
      "Abre Amigos.",
      "Busca al amigo en la lista.",
      "Revisa su estado visible.",
      "Usa la accion disponible para unirte o ver.",
      "Si no aparece, espera o pide una invitacion.",
    ],
    examples: [
      "Un amigo en partida puede mostrar una accion si la partida es compatible.",
      "Una partida privada puede requerir invitacion o clave.",
    ],
    faqs: [
      faq("Puedo entrar a cualquier partida de un amigo?", "No. Depende del estado y permisos de esa partida."),
      faq("Es lo mismo que Ver partidos?", "No. Ver partidos es una vista de espectador; Amigos parte de tu red social."),
    ],
    links: [
      link("Ver partidos", "ver-partidos"),
      link("Aceptar invitacion", "tutoriales/aceptar-invitacion-partida"),
      link("Partidas privadas", "partidas/publicas-y-privadas"),
    ],
    cta: { label: "Ver partidos", path: "ver-partidos" },
    sources: ["F21", "F34", "F32"],
  },
  {
    slug: "ver-partidos/en-vivo",
    category: "comunidad",
    title: "Partidas en vivo en XIMA | Ver partidos disponibles",
    metaDescription:
      "Conoce la vista de partidas en vivo de XIMA y como se relaciona con Ver partidos, espectadores y replays destacados.",
    h1: "Partidas en vivo",
    intro:
      "Partidas en vivo permite explorar encuentros disponibles desde la seccion Ver partidos cuando el sistema los ofrece.",
    verified:
      "SpectateMatches contiene vista para encontrar partidos, actualizar, ver replays y abrir repeticiones destacadas.",
    usage:
      "Usa la seccion para observar actividad publica o revisar partidas destacadas, segun los botones disponibles.",
    caution:
      "No todas las partidas activas son publicas, espectables o visibles.",
    examples: [
      "Ver partidos puede listar entradas con jugadores y modo.",
      "Un replay destacado puede abrirse aunque la partida ya haya terminado.",
    ],
    faqs: [
      faq("Puedo ver cualquier partida?", "No. Solo las que la plataforma exponga como disponibles o espectables."),
      faq("En vivo es igual a replay?", "No. En vivo es actividad actual; replay reproduce partidas registradas."),
    ],
    links: [
      link("Ver partidos", "ver-partidos"),
      link("Tarjetas de partido", "ver-partidos/tarjetas"),
      link("Replays destacados", "replays-destacados"),
    ],
    cta: { label: "Ver replays destacados", path: "replays-destacados" },
    sources: ["F17", "F32"],
  },
  {
    slug: "ver-partidos/tarjetas",
    category: "comunidad",
    title: "Tarjetas de partido en XIMA | Datos visibles al espectar",
    metaDescription:
      "Aprende a leer tarjetas de partido en XIMA: jugadores, modo, estado, replay y acciones disponibles.",
    h1: "Tarjetas de partido",
    intro:
      "Las tarjetas de partido resumen informacion visible para decidir si mirar una partida o abrir un replay.",
    verified:
      "La vista Ver partidos renderiza tarjetas con datos de match, jugadores, modo, puntuacion CIMAX cuando aplica y accion de replay.",
    usage:
      "Revisa nombre, jugadores, modo y disponibilidad antes de pulsar una accion.",
    caution:
      "Los datos pueden ser anonimizados, abreviados o depender del registro disponible.",
    examples: [
      "Una tarjeta puede mostrar una partida Humano contra Bot.",
      "Si no hay replay, el boton puede estar deshabilitado.",
    ],
    faqs: [
      faq("Las tarjetas muestran datos privados?", "La guia solo contempla datos visibles publicamente en la UI."),
      faq("Todas tienen boton de replay?", "No. Depende de si hay replay disponible."),
    ],
    links: [
      link("Ver partidos", "ver-partidos"),
      link("No hay replay guardado", "solucion/no-hay-replay"),
      link("Refrescar partidos", "ver-partidos/refrescar"),
    ],
    cta: { label: "Refrescar partidos", path: "ver-partidos/refrescar" },
    sources: ["F17"],
  },
  {
    slug: "ver-partidos/refrescar",
    category: "comunidad",
    title: "Refrescar partidos en XIMA | Actualizar vista de espectador",
    metaDescription:
      "Aprende para que sirve Actualizar o refrescar partidos en XIMA dentro de Ver partidos y replays destacados.",
    h1: "Refrescar partidos",
    intro:
      "Refrescar partidos solicita datos actualizados para la vista de espectador.",
    verified:
      "SpectateMatches contiene texto Actualizar y carga de partidos o replays destacados.",
    usage:
      "Usalo cuando la lista parece antigua, despues de esperar nuevas partidas o si acabas de entrar a Ver partidos.",
    caution:
      "Actualizar no garantiza que aparezcan partidas si no hay entradas disponibles.",
    steps: [
      "Abre Ver partidos.",
      "Pulsa Actualizar.",
      "Espera la carga.",
      "Revisa si cambiaron tarjetas o replays.",
      "Abre solo partidas o replays disponibles.",
    ],
    examples: [
      "Puede actualizar una lista de replays destacados.",
      "Puede seguir vacia si no hay datos para mostrar.",
    ],
    faqs: [
      faq("Actualizar crea partidas?", "No. Solo refresca la vista."),
      faq("Sirve si el replay falla?", "Puede ayudar a ver si la lista cambio, pero un replay faltante requiere otra revision."),
    ],
    links: [
      link("Tarjetas de partido", "ver-partidos/tarjetas"),
      link("Partidas en vivo", "ver-partidos/en-vivo"),
      link("No hay replay guardado", "solucion/no-hay-replay"),
    ],
    cta: { label: "Ver tarjetas", path: "ver-partidos/tarjetas" },
    sources: ["F17"],
  },
  {
    slug: "noticias",
    category: "interfaz",
    title: "Noticias de XIMA | Estado de contenido oficial",
    metaDescription:
      "Pagina noindex para Noticias de XIMA hasta que existan notas oficiales publicables y calendario editorial confirmado.",
    h1: "Noticias",
    intro:
      "Noticias existe como acceso visible, pero las publicaciones deben basarse en notas oficiales verificadas.",
    verified:
      "El menu contiene acceso a Noticias y puede mostrar contador o aviso visual.",
    usage:
      "Cuando haya notas aprobadas, esta pagina podra organizar anuncios, cambios y enlaces a versiones.",
    caution:
      "No se inventan fechas, lanzamientos, resultados ni comunicados sin fuente oficial.",
    confirmation:
      "Pendiente definir fuente editorial, formato de noticias y politica de actualizacion.",
    examples: [
      "Un contador puede indicar novedades visibles.",
      "Una noticia solo debe publicarse con contenido oficial.",
    ],
    faqs: [
      faq("Ya hay noticias publicables?", "No se confirma en esta guia."),
      faq("Por que noindex?", "Para no posicionar una pagina sin notas oficiales."),
    ],
    links: [
      link("Novedades", "novedades"),
      link("Lobby", "lobby"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver novedades", path: "novedades" },
    sources: ["F02", "F10", "F12"],
    status: "ownerConfirmation",
  },
  {
    slug: "novedades",
    category: "interfaz",
    title: "Novedades y versiones de XIMA | Pendiente de changelog",
    metaDescription:
      "Pagina noindex para novedades y versiones de XIMA hasta contar con changelog oficial, fechas y cambios aprobados.",
    h1: "Novedades y versiones",
    intro:
      "Una pagina de novedades debe depender de cambios oficiales, no de inferencias sobre el codigo.",
    verified:
      "El sitio tiene sitemap y secciones del producto, pero no se debe convertir el repositorio en changelog publico sin aprobacion.",
    usage:
      "Cuando haya versionado editorial, esta ruta puede agrupar cambios de Aprender, juego, tienda, torneos y soporte.",
    caution:
      "No se publican fechas de lanzamiento, promesas ni historia del producto sin confirmacion.",
    confirmation:
      "Pendiente crear politica de versiones, responsables, fechas y notas oficiales.",
    examples: [
      "Una novedad podria enlazar a guia de replay si el producto lo anuncia oficialmente.",
      "Una version deberia tener fecha y alcance aprobados.",
    ],
    faqs: [
      faq("Esta pagina esta lista?", "No. Se mantiene noindex hasta tener changelog oficial."),
      faq("Puede enlazar a Noticias?", "Si, cuando existan notas oficiales."),
    ],
    links: [
      link("Noticias", "noticias"),
      link("Aprender", ""),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Volver a Aprender", path: "" },
    sources: ["F02", "F10", "F12"],
    status: "ownerConfirmation",
  },
  {
    slug: "tutoriales/crear-torneo",
    category: "torneos",
    title: "Crear torneo en XIMA | Estado de flujo publico",
    metaDescription:
      "Pagina prudente sobre crear torneos en XIMA, marcada noindex hasta confirmar si el flujo es publico para jugadores.",
    h1: "Crear torneo",
    intro:
      "Crear torneo es un flujo sensible porque puede mezclar competencia, salas, costos o premios.",
    verified:
      "El proyecto contiene entidades y vistas de torneo, creacion de partidas y PlayTournaments.",
    usage:
      "Solo debe documentarse como tutorial publico si el propietario confirma que usuarios normales pueden crear torneos.",
    caution:
      "No se publican herramientas admin, costos, premios ni reglas de organizacion sin confirmacion.",
    confirmation:
      "Pendiente confirmar habilitacion publica del flujo Crear torneo y nombres exactos de botones.",
    examples: [
      "La plataforma maneja torneos y salas.",
      "No todo flujo de torneo debe presentarse como disponible para cualquier usuario.",
    ],
    faqs: [
      faq("Puedo crear torneos ahora?", "Esta guia no lo confirma. Requiere validacion del propietario."),
      faq("Por que noindex?", "Para evitar posicionar un flujo competitivo no confirmado."),
    ],
    links: [
      link("Torneos", "torneos"),
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Unirse a torneo", "tutoriales/unirse-a-torneo"),
    ],
    cta: { label: "Ver Torneos", path: "torneos" },
    sources: ["F12", "F16", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "torneos/sala-de-espera",
    category: "torneos",
    title: "Sala de espera de torneo XIMA | Jugadores y estado",
    metaDescription:
      "Aprende que muestra la sala de espera de torneo en XIMA: jugadores, posiciones, modo y boton para jugar.",
    h1: "Sala de espera de torneo",
    intro:
      "La sala de espera organiza participantes antes de jugar desde un torneo o partida preparada.",
    verified:
      "La interfaz contiene panel de espera con posiciones, jugadores, modo, puntuacion y accion para jugar desde sala.",
    usage:
      "Revisa participantes, estado y modo antes de iniciar o esperar que se complete la sala.",
    caution:
      "Las reglas finales de torneo, premios o ganador no se deducen solo de la sala de espera.",
    examples: [
      "La sala puede mostrar posiciones de jugadores.",
      "Puede existir un boton para jugar desde la sala cuando el estado lo permite.",
    ],
    faqs: [
      faq("La sala confirma el ganador?", "No. Solo organiza estado previo o intermedio."),
      faq("Puedo invitar desde sala?", "Existe pagina separada para invitar a torneo con cautelas."),
    ],
    links: [
      link("Jugar desde sala", "torneos/jugar-desde-sala"),
      link("Posiciones del torneo", "torneos/posiciones"),
      link("Chat de la sala", "torneos/chat-sala"),
    ],
    cta: { label: "Jugar desde sala", path: "torneos/jugar-desde-sala" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/chat-sala",
    category: "torneos",
    title: "Chat de la sala en XIMA | Comunicacion de torneo",
    metaDescription:
      "Guia del chat de sala en torneos de XIMA: uso publico, mensajes visibles y cautelas de privacidad.",
    h1: "Chat de la sala",
    intro:
      "El chat de sala permite comunicacion entre participantes dentro de un contexto de torneo o espera.",
    verified:
      "La interfaz de torneo y backend contemplan sala, miembros y comunicacion asociada al flujo de partida.",
    usage:
      "Usalo para coordinar inicio, dudas basicas o avisos de la sala sin compartir informacion sensible.",
    caution:
      "No compartas contrasenas personales, datos privados, pagos ni informacion de cuenta por chat.",
    examples: [
      "Un jugador puede avisar que esta listo.",
      "Un organizador puede orientar sobre esperar participantes si el flujo lo permite.",
    ],
    faqs: [
      faq("El chat es soporte oficial?", "No. Para problemas persistentes usa Soporte."),
      faq("Puedo enviar datos sensibles?", "No. Evita contrasenas, tokens o datos personales."),
    ],
    links: [
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Soporte", "soporte"),
      link("Chat de voz", "chat-de-voz"),
    ],
    cta: { label: "Ver sala de espera", path: "torneos/sala-de-espera" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/invitar",
    category: "torneos",
    title: "Invitar a torneo en XIMA | Participantes y sala",
    metaDescription:
      "Aprende que se puede documentar sobre invitar a torneo en XIMA sin confirmar premios, costos ni reglas privadas.",
    h1: "Invitar a torneo",
    intro:
      "Invitar a torneo conecta el flujo competitivo con jugadores que pueden participar en una sala.",
    verified:
      "El proyecto contiene salas, participantes, amigos e invitaciones de partida como sistemas relacionados.",
    usage:
      "Usa invitaciones solo cuando la UI habilite la accion y el jugador tenga acceso al torneo o sala correspondiente.",
    caution:
      "Falta confirmar el alcance publico exacto de invitar a torneo frente a invitar a partida.",
    confirmation:
      "Pendiente revisar nombres de botones y disponibilidad para usuarios normales.",
    examples: [
      "Una invitacion puede ayudar a completar una sala.",
      "Si el torneo es privado o cerrado, no debe asumirse acceso libre.",
    ],
    faqs: [
      faq("Es lo mismo que invitar amigo a partida?", "Es un flujo relacionado, pero puede depender del contexto de torneo."),
      faq("Puedo invitar a cualquiera?", "La guia no lo confirma; depende de permisos y UI."),
    ],
    links: [
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Invitar amigo a partida", "tutoriales/invitar-amigo-a-partida"),
      link("Amigos", "amigos"),
    ],
    cta: { label: "Ver sala", path: "torneos/sala-de-espera" },
    sources: ["F12", "F32"],
    status: "partial",
  },
  {
    slug: "torneos/salir-sala",
    category: "torneos",
    title: "Salir de la sala en XIMA | Torneos y espera",
    metaDescription:
      "Guia para salir de una sala de torneo en XIMA y entender que revisar antes de abandonar una espera.",
    h1: "Salir de la sala",
    intro:
      "Salir de la sala permite abandonar una vista o espera de torneo cuando no quieres continuar.",
    verified:
      "La interfaz contiene rutas de salida, volver al lobby y estados de sala relacionados con torneos.",
    usage:
      "Antes de salir, revisa si hay partida por comenzar o si abandonar puede afectar tu participacion.",
    caution:
      "Las consecuencias competitivas de salir deben confirmarse con reglas oficiales antes de prometer efectos.",
    steps: [
      "Revisa el estado de la sala.",
      "Confirma si hay partida lista para jugar.",
      "Usa la accion visible de salir o volver.",
      "Comprueba si regresas al lobby o vista anterior.",
      "Si fue un error, busca el torneo nuevamente si esta disponible.",
    ],
    examples: [
      "Puedes salir si entraste a la sala equivocada.",
      "Si el torneo esta por iniciar, conviene confirmar antes de abandonar.",
    ],
    faqs: [
      faq("Salir elimina mi cuenta?", "No. Solo abandona la sala o vista actual."),
      faq("Pierdo recompensa?", "No se confirma ninguna consecuencia economica sin reglas oficiales."),
    ],
    links: [
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Torneos activos", "torneos/activos"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver torneos activos", path: "torneos/activos" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/jugar-desde-sala",
    category: "torneos",
    title: "Jugar desde sala de espera XIMA | Iniciar partida",
    metaDescription:
      "Aprende como interpretar la accion de jugar desde sala de espera en XIMA y que condiciones revisar.",
    h1: "Jugar desde sala de espera",
    intro:
      "Jugar desde sala de espera abre la partida cuando el torneo o sala esta en estado compatible.",
    verified:
      "La UI contiene una accion de juego desde sala y muestra jugadores, posiciones y modo en el panel de espera.",
    usage:
      "Usala cuando la sala indique que estas listo y la partida pueda abrirse.",
    caution:
      "No se deben inventar condiciones de inicio si la UI o reglas oficiales no las muestran.",
    steps: [
      "Entra a la sala de espera.",
      "Revisa modo, jugadores y posicion.",
      "Espera que la accion de jugar este disponible.",
      "Pulsa jugar desde sala.",
      "Confirma que el tablero abra correctamente.",
    ],
    examples: [
      "El boton puede estar deshabilitado si faltan condiciones.",
      "La sala muestra informacion util antes de entrar al tablero.",
    ],
    faqs: [
      faq("Puedo jugar si faltan jugadores?", "Depende de las reglas del torneo o partida; no se asume."),
      faq("Que hago si no abre?", "Revisa Solucion de problemas o Soporte."),
    ],
    links: [
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Solucion de problemas", "solucion-de-problemas"),
      link("Unirse a torneo", "tutoriales/unirse-a-torneo"),
    ],
    cta: { label: "Ver solucion", path: "solucion-de-problemas" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/recompensas",
    category: "torneos",
    title: "Torneos con recompensa en XIMA | Revision pendiente",
    metaDescription:
      "Pagina noindex sobre recompensas de torneos en XIMA hasta confirmar reglas, costos, premios y lenguaje legal.",
    h1: "Torneo con recompensa",
    intro:
      "Las recompensas de torneo son informacion sensible y deben publicarse solo con reglas oficiales.",
    verified:
      "El modelo y los terminos contemplan campos de recompensa, pero la documentacion interna exige revision legal.",
    usage:
      "Antes de anunciar recompensas, deben confirmarse elegibilidad, monto, disponibilidad y condiciones.",
    caution:
      "No se publican premios, costos, disponibilidad ni promesas economicas sin aprobacion.",
    confirmation:
      "Pendiente revision legal y comercial del propietario.",
    examples: [
      "Un campo de recompensa en codigo no basta para prometer premios publicos.",
      "La pagina puede enlazar a tienda/recompensas solo cuando haya texto aprobado.",
    ],
    faqs: [
      faq("Hay recompensas garantizadas?", "No se confirma en esta pagina."),
      faq("Por que noindex?", "Porque involucra economia y reglas legales pendientes."),
    ],
    links: [
      link("Torneos", "torneos"),
      link("Tienda y recompensas", "tienda/recompensas"),
      link("Costo de torneo", "torneos/costo"),
    ],
    cta: { label: "Ver Torneos", path: "torneos" },
    sources: ["F12", "F29", "F32", "F35"],
    status: "ownerConfirmation",
  },
  {
    slug: "torneos/costo",
    category: "torneos",
    title: "Costo de torneo en XIMA | Pendiente de confirmacion",
    metaDescription:
      "Pagina noindex sobre costo de torneo en XIMA, creada para evitar publicar precios o condiciones no confirmadas.",
    h1: "Costo de torneo",
    intro:
      "El costo de torneo no debe publicarse sin confirmacion economica, legal y de disponibilidad.",
    verified:
      "El backend contiene normalizacion de costos o valores relacionados, pero eso no equivale a precio publico.",
    usage:
      "Si la UI muestra un costo, el jugador debe leerlo dentro del flujo oficial antes de confirmar participacion.",
    caution:
      "No se incluyen precios, descuentos, monedas ni politicas de reembolso no aprobadas.",
    confirmation:
      "Pendiente confirmar economia, terminos y textos finales.",
    examples: [
      "Un campo tecnico de costo no debe convertirse en anuncio publico.",
      "El costo visible en UI, si existe, debe revisarse contra terminos.",
    ],
    faqs: [
      faq("Cuanto cuesta un torneo?", "No se publica informacion de costo sin confirmacion."),
      faq("Esta pagina se publicara?", "Solo despues de revision legal y comercial."),
    ],
    links: [
      link("Torneos con recompensa", "torneos/recompensas"),
      link("Tienda", "tienda"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Ver soporte", path: "soporte" },
    sources: ["F12", "F29", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "torneos/posiciones",
    category: "torneos",
    title: "Posiciones del torneo XIMA | Tabla de participantes",
    metaDescription:
      "Aprende como leer posiciones del torneo en XIMA dentro de la sala de espera y vistas competitivas.",
    h1: "Posiciones del torneo",
    intro:
      "Las posiciones del torneo muestran el orden o lugar de participantes dentro de una sala o vista competitiva.",
    verified:
      "La UI de sala muestra filas de posicion, jugador, puntuacion y estado activo en torneo.",
    usage:
      "Usalas para entender la organizacion de participantes antes o durante el flujo del torneo.",
    caution:
      "No se deben interpretar como resultado final si la partida o torneo no ha terminado.",
    examples: [
      "Una fila puede mostrar posicion, avatar o iniciales y puntuacion.",
      "Un jugador activo puede destacarse visualmente.",
    ],
    faqs: [
      faq("Posicion es lo mismo que ranking global?", "No. Es contextual al torneo o sala."),
      faq("Define ganador?", "Solo si las reglas oficiales y estado final lo confirman."),
    ],
    links: [
      link("Ganador del torneo", "torneos/ganador"),
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Ranking", "ranking"),
    ],
    cta: { label: "Ver sala", path: "torneos/sala-de-espera" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/ganador",
    category: "torneos",
    title: "Ganador del torneo XIMA | Regla pendiente de confirmar",
    metaDescription:
      "Pagina noindex sobre ganador de torneo en XIMA hasta confirmar regla final, criterios y estados oficiales.",
    h1: "Ganador del torneo",
    intro:
      "La definicion de ganador de torneo debe basarse en reglas oficiales y estado final confirmado.",
    verified:
      "El sistema guarda historial, miembros y estados de torneo, pero la documentacion interna pide confirmar regla final.",
    usage:
      "Hasta confirmar, solo se puede decir que el producto maneja resultados y posiciones en flujos de torneo.",
    caution:
      "No se publican criterios de desempate, premios ni cierre oficial sin aprobacion.",
    confirmation:
      "Pendiente confirmar regla final de ganador, desempates y relacion con recompensas.",
    examples: [
      "Una posicion alta no siempre debe presentarse como ganador final.",
      "El resultado debe venir del estado oficial de la partida o torneo.",
    ],
    faqs: [
      faq("Como se define el ganador?", "Requiere confirmacion oficial."),
      faq("Por que existe la pagina?", "Para reservar una explicacion segura sin inventar reglas."),
    ],
    links: [
      link("Posiciones del torneo", "torneos/posiciones"),
      link("Torneos", "torneos"),
      link("Torneos con recompensa", "torneos/recompensas"),
    ],
    cta: { label: "Ver posiciones", path: "torneos/posiciones" },
    sources: ["F12", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "torneos/activos",
    category: "torneos",
    title: "Torneos activos en XIMA | Encontrar competiciones disponibles",
    metaDescription:
      "Conoce como interpretar torneos activos en XIMA y su relacion con unirse a torneo, sala de espera y estado disponible.",
    h1: "Torneos activos",
    intro:
      "Torneos activos son entradas disponibles o en curso dentro de los flujos competitivos visibles.",
    verified:
      "El backend consulta torneos y la UI contiene vistas de torneos, salas y listados disponibles.",
    usage:
      "Revisa estado, modo, participantes y accion disponible antes de intentar unirte.",
    caution:
      "Un torneo activo puede no estar abierto para todos si hay reglas, capacidad o estado especifico.",
    examples: [
      "Un torneo activo puede tener sala de espera.",
      "Si ya esta completo, puede no aceptar nuevos miembros.",
    ],
    faqs: [
      faq("Activo significa publico?", "No necesariamente. Activo indica estado, no acceso libre."),
      faq("Donde entro?", "Consulta Unirse a torneo y Sala de espera."),
    ],
    links: [
      link("Unirse a torneo", "tutoriales/unirse-a-torneo"),
      link("Sala de espera", "torneos/sala-de-espera"),
      link("Torneos futuros", "torneos/futuros"),
    ],
    cta: { label: "Unirse a torneo", path: "tutoriales/unirse-a-torneo" },
    sources: ["F12", "F32"],
  },
  {
    slug: "torneos/futuros",
    category: "torneos",
    title: "Torneos futuros en XIMA | Calendario pendiente",
    metaDescription:
      "Pagina noindex sobre torneos futuros en XIMA hasta confirmar calendario, fechas oficiales y politica de anuncios.",
    h1: "Torneos futuros",
    intro:
      "Los torneos futuros solo deben publicarse con calendario y fechas oficiales.",
    verified:
      "El proyecto tiene campos y flujos de torneo, pero no se debe inventar un calendario publico.",
    usage:
      "Cuando exista calendario aprobado, esta ruta podra listar proximos eventos y enlaces a reglas.",
    caution:
      "No se publican fechas, horarios, premios ni inscripciones sin confirmacion.",
    confirmation:
      "Pendiente confirmar calendario oficial y fuente de anuncios.",
    examples: [
      "Una pagina futura podria enlazar a Noticias.",
      "Una fecha visible debe provenir de una fuente aprobada.",
    ],
    faqs: [
      faq("Hay calendario publicado?", "No se confirma en esta guia."),
      faq("Por que noindex?", "Porque no hay agenda oficial publicable."),
    ],
    links: [
      link("Noticias", "noticias"),
      link("Torneos activos", "torneos/activos"),
      link("Torneos", "torneos"),
    ],
    cta: { label: "Ver torneos activos", path: "torneos/activos" },
    sources: ["F12", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "puzzles/modos",
    category: "entrenamiento",
    title: "Puzzles por modo en XIMA | Practicar Ciencia, Azar y mas",
    metaDescription:
      "Aprende como los puzzles de XIMA pueden organizarse por modo y que limites deben respetarse en la explicacion publica.",
    h1: "Puzzles por modo",
    intro:
      "Puzzles por modo ayuda a practicar situaciones segun la categoria de juego asociada.",
    verified:
      "El dashboard de puzzles contiene filtros por modo y resolucion de modo base como Ciencia, Azar, Cienzar y FreeBox.",
    usage:
      "Filtra por el modo que quieres entrenar y compara reglas con la guia correspondiente antes de jugar.",
    caution:
      "Cienzar y recompensas de puzzle requieren confirmacion antes de explicaciones avanzadas.",
    examples: [
      "Un puzzle de Azar puede relacionarse con reglas de dados.",
      "Un puzzle de Ciencia puede concentrarse en lectura de tablero.",
    ],
    faqs: [
      faq("Los puzzles tienen todos los modos?", "La UI permite filtros, pero la disponibilidad depende de puzzles guardados."),
      faq("Puedo crear puzzles?", "La creacion publica no debe documentarse como general; hay herramientas autorizadas."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Resolver puzzle", "tutoriales/resolver-puzzle"),
      link("Modo Ciencia", "ciencia"),
    ],
    cta: { label: "Resolver puzzle", path: "tutoriales/resolver-puzzle" },
    sources: ["F12", "F32"],
  },
  {
    slug: "puzzles/recompensas",
    category: "entrenamiento",
    title: "Recompensa de puzzle en XIMA | Revision legal pendiente",
    metaDescription:
      "Pagina noindex sobre recompensas de puzzle en XIMA hasta confirmar reglas, elegibilidad y lenguaje legal.",
    h1: "Recompensa de puzzle",
    intro:
      "Las recompensas de puzzle existen como dato del sistema, pero su explicacion publica requiere revision.",
    verified:
      "El dashboard y backend contemplan valores de recompensa, reclamo y estado de puzzles resueltos o fallidos.",
    usage:
      "Si la UI muestra recompensa, el jugador debe seguir el flujo oficial y leer condiciones visibles.",
    caution:
      "No se publican montos, garantias, disponibilidad diaria ni condiciones economicas sin aprobacion.",
    confirmation:
      "Pendiente revision legal de recompensas, elegibilidad y reclamo.",
    examples: [
      "Un puzzle puede mostrar un valor de recompensa.",
      "La guia no debe prometer que todos los puzzles pagan recompensa.",
    ],
    faqs: [
      faq("Todos los puzzles dan recompensa?", "No se confirma. Depende de datos visibles y reglas oficiales."),
      faq("Por que noindex?", "Porque involucra economia y condiciones pendientes."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Puzzle completado", "puzzles/completado"),
      link("Tienda y recompensas", "tienda/recompensas"),
    ],
    cta: { label: "Ver Puzzles", path: "puzzles" },
    sources: ["F12", "F29", "F32"],
    status: "ownerConfirmation",
  },
  {
    slug: "puzzles/tiempo",
    category: "entrenamiento",
    title: "Tiempo de solucion de puzzle XIMA | Limites y lectura",
    metaDescription:
      "Conoce el tiempo de solucion de puzzle en XIMA, como aparece en reglas de puzzle y que significa para practicar.",
    h1: "Tiempo de solucion de puzzle",
    intro:
      "Algunos puzzles pueden tener limite de tiempo de solucion junto con limite de movimientos.",
    verified:
      "El backend y dashboard normalizan puzzleSolveTimeLimitSeconds y generan titulos como llegar a la cima con tiempo.",
    usage:
      "Lee el tiempo como una condicion del reto: debes resolver dentro del limite si el puzzle lo muestra.",
    caution:
      "La disponibilidad y valor exacto dependen de cada puzzle; no se debe generalizar a todos.",
    examples: [
      "Un puzzle puede pedir llegar a la cima en cierta cantidad de movimientos y minutos.",
      "Si no hay tiempo configurado, el reto puede centrarse en movimientos.",
    ],
    faqs: [
      faq("Todos los puzzles tienen tiempo?", "No. El sistema contempla limite opcional."),
      faq("Tiempo y movimientos son lo mismo?", "No. Son condiciones distintas del reto."),
    ],
    links: [
      link("Resolver puzzle", "tutoriales/resolver-puzzle"),
      link("Puzzles por modo", "puzzles/modos"),
      link("Puzzle fallido", "puzzles/fallido"),
    ],
    cta: { label: "Resolver puzzle", path: "tutoriales/resolver-puzzle" },
    sources: ["F12", "F32"],
  },
  {
    slug: "puzzles/completado",
    category: "entrenamiento",
    title: "Puzzle completado en XIMA | Que significa resolverlo",
    metaDescription:
      "Aprende que significa puzzle completado en XIMA, como se relaciona con solucion, recompensa y progreso de entrenamiento.",
    h1: "Puzzle completado",
    intro:
      "Un puzzle completado indica que el jugador resolvio el reto bajo las condiciones disponibles.",
    verified:
      "El backend y dashboard manejan puzzles resueltos, reclamos de recompensa y estados de progreso por usuario.",
    usage:
      "Despues de completar, revisa si hay resultado, recompensa o siguiente puzzle visible en la interfaz.",
    caution:
      "No todos los puzzles deben prometer recompensa; ese punto requiere condiciones oficiales.",
    examples: [
      "Un puzzle puede marcarse resuelto despues de alcanzar el objetivo.",
      "La UI puede permitir reclamar recompensa si aplica.",
    ],
    faqs: [
      faq("Completado significa recompensa garantizada?", "No. Recompensas dependen de reglas y datos del puzzle."),
      faq("Puedo repetir un puzzle completado?", "Consulta la guia Reintentar puzzle; la disponibilidad depende del flujo."),
    ],
    links: [
      link("Reintentar puzzle", "tutoriales/reintentar-puzzle"),
      link("Recompensa de puzzle", "puzzles/recompensas"),
      link("Siguiente puzzle", "tutoriales/siguiente-puzzle"),
    ],
    cta: { label: "Siguiente puzzle", path: "tutoriales/siguiente-puzzle" },
    sources: ["F12", "F32"],
  },
  {
    slug: "puzzles/fallido",
    category: "entrenamiento",
    title: "Puzzle fallido en XIMA | Reintentar y aprender",
    metaDescription:
      "Guia sobre puzzle fallido en XIMA: que revisar, como reintentar y cuando consultar solucion de problemas.",
    h1: "Puzzle fallido",
    intro:
      "Un puzzle fallido indica que el intento no cumplio las condiciones del reto.",
    verified:
      "El sistema maneja estados de puzzle fallado, intentos y registros de fallo para el jugador.",
    usage:
      "Revisa limite de movimientos, tiempo, modo y objetivo antes de intentar otra vez.",
    caution:
      "Si el fallo viene de carga o tablero, consulta solucion de problemas en lugar de asumir error de reglas.",
    steps: [
      "Lee el objetivo del puzzle.",
      "Revisa si fallaste por movimientos, tiempo o jugada.",
      "Consulta la regla relacionada.",
      "Usa Reintentar si esta disponible.",
      "Contacta soporte si el puzzle no carga correctamente.",
    ],
    examples: [
      "Agotar movimientos puede marcar el intento como fallido.",
      "Una jugada no permitida puede bloquear la ruta esperada.",
    ],
    faqs: [
      faq("Fallido borra mi cuenta?", "No. Es solo estado del intento de puzzle."),
      faq("Puedo recuperar recompensa?", "Depende de reglas oficiales; no se promete en esta guia."),
    ],
    links: [
      link("Reintentar puzzle", "tutoriales/reintentar-puzzle"),
      link("Movimiento no permitido", "solucion/movimiento-no-permitido"),
      link("Soporte", "soporte"),
    ],
    cta: { label: "Reintentar puzzle", path: "tutoriales/reintentar-puzzle" },
    sources: ["F12", "F32"],
  },
  {
    slug: "tutoriales/abrir-puzzle",
    category: "tutorial",
    title: "Abrir puzzle en XIMA | Entrar a un reto de entrenamiento",
    metaDescription:
      "Aprende como abrir un puzzle en XIMA desde el dashboard, revisar modo, objetivo y empezar a practicar.",
    h1: "Abrir puzzle",
    intro:
      "Abrir puzzle carga un reto de entrenamiento para intentar resolver una posicion o secuencia.",
    verified:
      "El dashboard de puzzles permite cargar puzzles y el backend tiene rutas de carga de snapshot de puzzle.",
    usage:
      "Antes de abrir, revisa modo, recompensa si aparece, movimientos y tiempo si estan visibles.",
    caution:
      "No documentes herramientas de crear o certificar puzzle como si fueran de usuario general.",
    steps: [
      "Abre la seccion Puzzles.",
      "Filtra o busca el puzzle deseado.",
      "Revisa datos visibles del reto.",
      "Pulsa la accion para abrirlo.",
      "Espera que el tablero cargue la posicion.",
      "Juega el intento segun las reglas del puzzle.",
    ],
    examples: [
      "Puedes abrir un puzzle reciente o filtrar por modo.",
      "Si no carga, revisa soporte o problema de puzzle.",
    ],
    faqs: [
      faq("Abrir puzzle modifica partidas online?", "No. Es un flujo de entrenamiento."),
      faq("Puedo abrir cualquier puzzle?", "Depende de disponibilidad y permisos visibles."),
    ],
    links: [
      link("Puzzles", "puzzles"),
      link("Puzzles por modo", "puzzles/modos"),
      link("Puzzle fallido", "puzzles/fallido"),
    ],
    cta: { label: "Ver Puzzles", path: "puzzles" },
    sources: ["F12", "F32"],
  },
  {
    slug: "tutoriales/reintentar-puzzle",
    category: "tutorial",
    title: "Reintentar puzzle en XIMA | Practicar despues de fallar",
    metaDescription:
      "Guia para reintentar un puzzle en XIMA, revisar la causa del fallo y volver a practicar de forma ordenada.",
    h1: "Reintentar puzzle",
    intro:
      "Reintentar puzzle te permite volver a practicar un reto despues de fallar o querer mejorar la solucion.",
    verified:
      "La UI y estados internos contemplan intentos, puzzles fallidos y claves de reintento relacionadas con abrir puzzle.",
    usage:
      "Antes de reintentar, identifica si fallaste por movimiento, tiempo, objetivo o lectura del tablero.",
    caution:
      "La disponibilidad de reintento y recompensa puede depender de reglas del puzzle.",
    steps: [
      "Abre el puzzle fallido o su tarjeta.",
      "Revisa objetivo, limite de movimientos y tiempo.",
      "Identifica la primera jugada dudosa.",
      "Usa la accion de reintento si esta disponible.",
      "Prueba una ruta corregida.",
    ],
    examples: [
      "Si fallaste por tiempo, prepara la ruta antes de mover.",
      "Si fallaste por jugada ilegal, revisa reglas de movimiento.",
    ],
    faqs: [
      faq("Reintentar garantiza recompensa?", "No. Depende de reglas y estado del puzzle."),
      faq("Debo cambiar de modo?", "No necesariamente; primero entiende la condicion del puzzle."),
    ],
    links: [
      link("Puzzle fallido", "puzzles/fallido"),
      link("Tiempo de solucion", "puzzles/tiempo"),
      link("Jugada legal", "reglas/jugada-legal"),
    ],
    cta: { label: "Ver jugada legal", path: "reglas/jugada-legal" },
    sources: ["F12", "F32"],
  },
  {
    slug: "tutoriales/siguiente-puzzle",
    category: "tutorial",
    title: "Siguiente puzzle en XIMA | Continuar entrenamiento",
    metaDescription:
      "Aprende como continuar al siguiente puzzle en XIMA y como elegir retos por modo, tiempo o dificultad visible.",
    h1: "Siguiente puzzle",
    intro:
      "Siguiente puzzle ayuda a continuar entrenando despues de completar o revisar un reto.",
    verified:
      "El dashboard maneja listados ordenados de puzzles, busqueda, filtros y flujo de apertura de siguiente reto.",
    usage:
      "Elige el siguiente reto segun modo, objetivo o estado visible, en lugar de avanzar sin revisar la solucion anterior.",
    caution:
      "No se confirma una progresion oficial fija de dificultad para todos los puzzles.",
    steps: [
      "Termina o cierra el puzzle actual.",
      "Vuelve al listado de puzzles.",
      "Usa filtros por modo si quieres practicar una categoria.",
      "Elige otro puzzle disponible.",
      "Abre el reto y revisa sus condiciones.",
    ],
    examples: [
      "Despues de resolver un puzzle de Ciencia, puedes buscar otro del mismo modo.",
      "Ordenar por reciente o recompensa puede cambiar la lista visible.",
    ],
    faqs: [
      faq("Hay una ruta oficial de niveles?", "No se confirma una progresion oficial completa."),
      faq("Conviene saltar rapidamente?", "Para aprender, revisa primero por que la solucion funciono o fallo."),
    ],
    links: [
      link("Puzzles por modo", "puzzles/modos"),
      link("Puzzle completado", "puzzles/completado"),
      link("Abrir puzzle", "tutoriales/abrir-puzzle"),
    ],
    cta: { label: "Abrir puzzle", path: "tutoriales/abrir-puzzle" },
    sources: ["F12", "F32"],
  },
  {
    slug: "bots/modo-libre",
    category: "bots",
    title: "Modo bot libre en XIMA | Nombre pendiente de validar",
    metaDescription:
      "Pagina noindex sobre modo bot libre en XIMA hasta validar el nombre publico y su relacion con Ciencia o FreeBox.",
    h1: "Modo bot libre",
    intro:
      "Modo bot libre es una forma prudente de referirse a entrenamiento con bot sin dados, pero el nombre publico necesita validacion.",
    verified:
      "PlayBot contiene modos bot locales y referencias a Ciencia, Azar, Cienzar y Ciencia V/S Azar.",
    usage:
      "Hasta validar el nombre, conviene dirigir al usuario a Bots de XIMA y Modo Ciencia.",
    caution:
      "No se debe indexar una etiqueta de modo que puede no ser el nombre final del producto.",
    confirmation:
      "Pendiente validar si el nombre publico debe ser Modo Ciencia, Bot Ciencia, modo libre u otra etiqueta.",
    examples: [
      "El bot puede jugar en un modo asociado a Ciencia.",
      "La UI usa etiquetas de modo con bot, no necesariamente este slug.",
    ],
    faqs: [
      faq("Este es el nombre oficial?", "No. Esta pendiente de validacion."),
      faq("Donde aprendo bot confirmado?", "Consulta Bots de XIMA y Jugar con bot."),
    ],
    links: [
      link("Bots de XIMA", "bots"),
      link("Jugar con bot", "tutoriales/jugar-con-bot"),
      link("Bot Ciencia V/S Azar", "bots/ciencia-vs-azar"),
    ],
    cta: { label: "Ver Bots", path: "bots" },
    sources: ["F13", "F39", "F42"],
    status: "ownerConfirmation",
  },
  {
    slug: "bots/azar",
    category: "bots",
    title: "Bot con dados en XIMA | Entrenar Modo Azar",
    metaDescription:
      "Conoce el bot con dados en XIMA, como se relaciona con Modo Azar, dificultad y practica contra IA.",
    h1: "Bot con dados",
    intro:
      "Bot con dados permite practicar contra IA en un contexto asociado a Azar.",
    verified:
      "PlayBot muestra Modo Azar con texto de jugar con dados contra el bot y el proyecto contiene scripts de dados y bots.",
    usage:
      "Usalo para entrenar lectura de jugadas cuando el resultado de dados influye en la decision.",
    caution:
      "No se publican algoritmos ni heuristicas del bot.",
    examples: [
      "Puedes practicar como responder a un resultado de dados.",
      "La dificultad del bot puede cambiar la presion de entrenamiento.",
    ],
    faqs: [
      faq("El bot con dados usa las mismas reglas de Azar?", "La guia confirma la relacion visible con Azar, sin detallar implementacion interna."),
      faq("Puedo elegir dificultad?", "La pantalla de bot permite elegir nivel de IA."),
    ],
    links: [
      link("Modo Azar", "azar"),
      link("Dados en XIMA", "reglas/dados"),
      link("Dificultad de bot", "bots/dificultad"),
    ],
    cta: { label: "Ver dificultad", path: "bots/dificultad" },
    sources: ["F13", "F42"],
  },
  {
    slug: "bots/cienzar",
    category: "bots",
    title: "Bot Cienzar en XIMA | Pendiente de confirmacion",
    metaDescription:
      "Pagina noindex sobre Bot Cienzar en XIMA hasta confirmar reglas del modo, nombre publico y comportamiento de IA.",
    h1: "Bot Cienzar",
    intro:
      "Bot Cienzar aparece en el proyecto, pero la explicacion publica depende de confirmar el modo Cienzar.",
    verified:
      "PlayBot contiene Modo Cienzar y el proyecto tiene scripts relacionados con CienzarBot.",
    usage:
      "Por ahora se debe explicar solo como opcion visible de entrenamiento, no como estrategia o regla oficial completa.",
    caution:
      "No se publican algoritmos, heuristicas ni definiciones no aprobadas de Cienzar.",
    confirmation:
      "Pendiente confirmar reglas de Cienzar y descripcion oficial del bot.",
    examples: [
      "La UI describe Cienzar como estrategia y suerte juntas.",
      "El bot puede estar asociado a ese modo, pero los detalles siguen privados.",
    ],
    faqs: [
      faq("Puedo indexar esta pagina?", "No hasta confirmar Cienzar."),
      faq("Se explica la IA?", "No. Solo se reconoce la opcion visible."),
    ],
    links: [
      link("Modo Cienzar", "cienzar"),
      link("Cienzar hibrido", "modos/cienzar-ciencia-y-azar"),
      link("Bots de XIMA", "bots"),
    ],
    cta: { label: "Ver Bots", path: "bots" },
    sources: ["F13", "F38", "F42"],
    status: "ownerConfirmation",
  },
  {
    slug: "bots/ciencia-vs-azar",
    category: "bots",
    title: "Bot Ciencia V/S Azar en XIMA | Roles de IA",
    metaDescription:
      "Aprende como se presenta Bot Ciencia V/S Azar en XIMA, con roles de ciencia o azar segun la interfaz.",
    h1: "Bot Ciencia V/S Azar",
    intro:
      "Bot Ciencia V/S Azar permite entrenar contra IA en un modo con roles diferenciados.",
    verified:
      "PlayBot describe Ciencia V/S Azar como IA con roles fijos y dice que el bot juega ciencia o azar segun el rol asignado.",
    usage:
      "Usalo para practicar partidas donde una parte puede seguir reglas de Ciencia y otra reglas de Azar.",
    caution:
      "No se publican criterios internos de seleccion de jugadas del bot.",
    examples: [
      "El bot puede representar el rol de Ciencia o Azar.",
      "La comparacion ayuda a estudiar decisiones contra dados.",
    ],
    faqs: [
      faq("El rol cambia durante la partida?", "La UI habla de roles fijos; no se amplian casos no confirmados."),
      faq("Es igual que Contrazar?", "No se afirma eso. Contrazar necesita confirmacion terminologica."),
    ],
    links: [
      link("Ciencia V/S Azar", "modos/ciencia-vs-azar"),
      link("Bot con dados", "bots/azar"),
      link("Dificultad de bot", "bots/dificultad"),
    ],
    cta: { label: "Ver Ciencia V/S Azar", path: "modos/ciencia-vs-azar" },
    sources: ["F13", "F38", "F42"],
  },
  {
    slug: "bots/dificultad",
    category: "bots",
    title: "Dificultad de bot en XIMA | Facil, medio y dificil",
    metaDescription:
      "Conoce la dificultad de bot en XIMA, sus niveles visibles y como elegir un reto adecuado para entrenar.",
    h1: "Dificultad de bot",
    intro:
      "La dificultad de bot ajusta el nivel de presion de la IA en partidas de entrenamiento.",
    verified:
      "PlayBot muestra Dificultad y niveles Facil, Medio, Dificil e Injusto con descripciones publicas.",
    usage:
      "Elige Facil para practicar, Medio para un reto equilibrado y Dificil para mayor presion.",
    caution:
      "No se publican algoritmos ni se promete una escala exacta de fuerza.",
    steps: [
      "Abre Jugar con bot.",
      "Selecciona modo de juego.",
      "Elige cantidad de rivales bot.",
      "Busca la seccion Dificultad.",
      "Selecciona el nivel adecuado.",
      "Pulsa Jugar.",
    ],
    examples: [
      "Facil se describe como para practicar.",
      "Dificil se presenta como solo para expertos.",
    ],
    faqs: [
      faq("Dificultad cambia las reglas?", "No se afirma; se presenta como nivel de IA."),
      faq("Existe Injusto?", "La UI contiene nivel Injusto, pero este bloque de 100 documenta hasta Dificil."),
    ],
    links: [
      link("Bot facil", "bots/dificultad-facil"),
      link("Bot medio", "bots/dificultad-media"),
      link("Bot dificil", "bots/dificultad-dificil"),
    ],
    cta: { label: "Ver bot facil", path: "bots/dificultad-facil" },
    sources: ["F13", "F38", "F42"],
  },
  {
    slug: "bots/dificultad-facil",
    category: "bots",
    title: "Bot facil en XIMA | Practicar contra IA",
    metaDescription:
      "Aprende cuando elegir Bot facil en XIMA y como usarlo para practicar reglas, movimientos y lectura de tablero.",
    h1: "Bot facil",
    intro:
      "Bot facil es el nivel recomendado para practicar sin maxima presion.",
    verified:
      "La UI de PlayBot muestra Facil con detalle Para practicar.",
    usage:
      "Elige este nivel si estas aprendiendo movimientos, dados o rutas hacia la cima.",
    caution:
      "No se debe presentar como tutorial automatico ni como garantia de victoria.",
    steps: [
      "Abre Jugar con bot.",
      "Elige un modo conocido.",
      "Selecciona Dificultad Facil.",
      "Configura jugadores y tiempo.",
      "Pulsa Jugar.",
      "Revisa el replay para aprender.",
    ],
    examples: [
      "Facil ayuda a probar jugadas sin tanta presion.",
      "Si dominas las reglas, puedes pasar a Medio.",
    ],
    faqs: [
      faq("Facil significa que siempre gano?", "No. Solo indica un nivel de IA pensado para practicar."),
      faq("Sirve para principiantes?", "Si, es la mejor opcion visible para empezar con bot."),
    ],
    links: [
      link("Dificultad de bot", "bots/dificultad"),
      link("Bot medio", "bots/dificultad-media"),
      link("Como jugar XIMA", "como-jugar"),
    ],
    cta: { label: "Ver bot medio", path: "bots/dificultad-media" },
    sources: ["F13", "F38", "F42"],
  },
  {
    slug: "bots/dificultad-media",
    category: "bots",
    title: "Bot medio en XIMA | Desafio equilibrado",
    metaDescription:
      "Conoce Bot medio en XIMA, un nivel de IA visible como desafio equilibrado para seguir entrenando.",
    h1: "Bot medio",
    intro:
      "Bot medio ofrece una practica mas exigente que Facil sin llegar al nivel mas alto visible.",
    verified:
      "La UI de PlayBot muestra Medio con detalle Desafio equilibrado.",
    usage:
      "Usalo cuando ya conoces objetivo, movimientos y modo, y quieres evaluar decisiones con mas presion.",
    caution:
      "La guia no revela como decide la IA ni mide dificultad con estadisticas externas.",
    steps: [
      "Abre Jugar con bot.",
      "Selecciona modo.",
      "Elige Dificultad Medio.",
      "Ajusta tiempo por turno.",
      "Inicia la partida.",
      "Analiza errores desde historial o replay.",
    ],
    examples: [
      "Medio puede servir para pasar de practica a reto.",
      "Si se vuelve sencillo, revisa Bot dificil.",
    ],
    faqs: [
      faq("Medio es competitivo oficial?", "No. Es un nivel de entrenamiento contra IA."),
      faq("Cambia por modo?", "La experiencia puede variar por modo, pero no se explican algoritmos."),
    ],
    links: [
      link("Bot facil", "bots/dificultad-facil"),
      link("Bot dificil", "bots/dificultad-dificil"),
      link("Historial y replay", "historial-y-replay"),
    ],
    cta: { label: "Ver bot dificil", path: "bots/dificultad-dificil" },
    sources: ["F13", "F38", "F42"],
  },
  {
    slug: "bots/dificultad-dificil",
    category: "bots",
    title: "Bot dificil en XIMA | Entrenamiento avanzado",
    metaDescription:
      "Aprende cuando usar Bot dificil en XIMA, nivel visible para expertos dentro de la practica contra IA.",
    h1: "Bot dificil",
    intro:
      "Bot dificil aumenta la exigencia de entrenamiento contra IA para jugadores que ya entienden reglas y modos.",
    verified:
      "La UI de PlayBot muestra Dificil con detalle Solo para expertos.",
    usage:
      "Usalo cuando quieras probar decisiones bajo presion y despues revisar la partida con replay.",
    caution:
      "No se publican heuristicas internas ni se garantiza equivalencia con jugadores humanos.",
    steps: [
      "Domina primero reglas y modo elegido.",
      "Abre Jugar con bot.",
      "Selecciona Dificultad Dificil.",
      "Configura tiempo suficiente para analizar.",
      "Juega la partida.",
      "Revisa replay y estadisticas al terminar.",
    ],
    examples: [
      "Dificil es adecuado si Facil y Medio ya no te retan.",
      "El replay ayuda a estudiar por que el bot encontro una respuesta fuerte.",
    ],
    faqs: [
      faq("Dificil es imposible?", "No se afirma. Solo es el nivel visible indicado para expertos."),
      faq("El bot revela estrategia perfecta?", "No. La IA no se presenta como infalible."),
    ],
    links: [
      link("Dificultad de bot", "bots/dificultad"),
      link("Bots de XIMA", "bots"),
      link("Ver replay", "tutoriales/ver-replay"),
    ],
    cta: { label: "Ver Bots de XIMA", path: "bots" },
    sources: ["F13", "F38", "F42"],
  },
];

export const NEXT_HUNDRED_LEARN_SLUGS = NEXT_HUNDRED_TOPICS.map((topic) => topic.slug);

export const buildNextHundredLearnPages = (deps) =>
  NEXT_HUNDRED_TOPICS.map((topic) => buildLearnPage(deps, topic));
